// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { addRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPost, addUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPost, batchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPost, bulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePost, bulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPost, bulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPost, bulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPost, bulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPost, bulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPost, bulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPost, bulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPost, classifyByTitleV1ProductCategoriesClassifyByTitlePost, completeAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGet, complexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPost, complexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPost, createAnalyticsTokenV1AnalyticsAuthPost, createClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPost, createCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPost, createCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPost, createExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPost, createExploreImageV1ExploreImagesPost, createExplorePdpV1ExplorePdpsPost, createIdeaForImageV1InternalImagesImageIdIdeasPost, createIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPost, createIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPost, createImageClassificationV1AssetsImagesImageIdClassificationPost, createImageScoreV1AssetsImagesImageIdRawScorePost, createMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePost, createOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPost, createOrganizationV1OrganizationsPost, createPdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPost, createPdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPost, createPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPost, createPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPost, createPdpV1PortfoliosPortfolioIdPdpsPost, createPdpV1WorkspacesWorkspaceIdPdpsPost, createQueryV1ExploreQueriesPost, createRoleAssignmentV1RoleAssignmentsPost, createScoringResultsV1InternalImagesImageIdScoringResultsPost, createUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPost, createUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPost, deleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDelete, deleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDelete, deleteExploreImageV1ExploreImagesExploreImageIdDelete, deleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete, deleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete, deleteImageGenPromptV1ImageGenPromptsPromptIdDelete, deleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDelete, deleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDelete, deleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDelete, deletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDelete, deletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDelete, deletePdpV1PortfoliosPortfolioIdPdpsPdpIdDelete, deletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDelete, deleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDelete, deleteUserV1UsersUserIdDelete, disconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDelete, downloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGet, downloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGet, exchangeTokenV1OrganizationsOrganizationIdAuthorizePost, exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGet, exportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGet, favoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePut, favoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePut, findIntegrationV1IntegrationsGet, generatePromptsForImageV1ImagesImageIdGeneratePromptsPost, getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGet, getArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGet, getAudienceV1AudiencesAudienceIdGet, getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGet, getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet, getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGet, getBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGet, getBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGet, getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGet, getBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGet, getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGet, getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGet, getCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGet, getCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGet, getCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGet, getDispatchContextV1InternalImagesImageIdDispatchContextGet, getExploreImageV1ExploreImagesExploreImageIdGet, getExplorePdpV1ExplorePdpsExplorePdpIdGet, getFeatureFlagV1FeatureFlagsFlagGet, getFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGet, getIcpProductCategoriesV1IcpProductCategoriesGet, getIcpProductCategoriesV1L1ProductCategoriesGet, getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGet, getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGet, getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGet, getIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGet, getImageByIdV1ImagesImageIdGet, getImageClassificationV1ExploreClassificationsClassificationIdGet, getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGet, getImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGet, getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet, getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet, getImageGenPromptV1ImageGenPromptsPromptIdGet, getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGet, getImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGet, getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGet, getImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGet, getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGet, getImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGet, getImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGet, getImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGet, getImagesScoringDataV1InternalImagesScoringDataGet, getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGet, getImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGet, getIntegrationV1IntegrationsIntegrationIdGet, getMeV1MeGet, getOrganizationNameV1InternalOrganizationsOrgIdNameGet, getOrganizationsForUserV1UsersUserIdOrganizationsGet, getOrganizationV1OrganizationsOrgIdGet, getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGet, getOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGet, getPdpScoringContextV1InternalPdpsPdpIdScoringContextGet, getPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGet, getPdpV1PortfoliosPortfolioIdPdpsPdpIdGet, getPdpV1WorkspacesWorkspaceIdPdpsPdpIdGet, getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet, getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGet, getProductCategoriesV1ProductCategoriesGet, getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGet, getProductCategoryV1ProductCategoriesCategoryIdGet, getQueryV1ExploreQueriesQueryIdGet, getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGet, getRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGet, getRetailerRegionV1RetailerRegionsRetailerRegionIdGet, getRetailersForOrganizationV1OrganizationsOrgIdRetailersGet, getScrapedPdpV1PdpsRequestIdGet, getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet, getUserV1UsersUserIdGet, getWorkspaceBySlugV1WorkspacesBySlugSlugGet, handleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPost, healthcheckGet, healthcheckHealthcheckGet, listActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGet, listAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGet, listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet, listCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGet, listCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGet, listExploreImagesV1ExploreImagesGet, listFeatureFlagsV1FeatureFlagsGet, listImageClassificationsV1ExploreClassificationsGet, listRetailerRegionsV1RetailerRegionsGet, loginUserV1UsersAuthenticatePost, logoutUserV1UsersUserIdLogoutPost, lookupCategoriesV1InternalProductCategoriesLookupGet, lookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPost, type Options, postProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPost, postScoringCompleteV1InternalPdpsPdpIdScoringCompletePost, processBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPost, readyReadyGet, reconcileStaleBulkInvitesV1BulkInviteReconcileStalePost, refreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPost, refreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPost, removeRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDelete, removeUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDelete, renameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatch, renameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatch, replaceExploreImageV1ExploreImagesExploreImageIdPut, resendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePost, resetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPost, resetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPost, resetPasswordV1UsersPasswordPut, scrapeCompleteV1InternalPdpsPdpIdScrapeCompletePost, searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet, searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGet, searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet, searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGet, searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet, searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGet, searchImagesV1PortfoliosPortfolioIdAssetsImagesGet, searchImagesV1WorkspacesWorkspaceIdAssetsImagesGet, searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet, searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGet, searchPdpsV1PortfoliosPortfolioIdPdpsGet, searchPdpsV1WorkspacesWorkspaceIdPdpsGet, searchRoleAssignmentsV1RoleAssignmentsGet, setPasswordV1UsersUserIdPasswordPost, setPdpCategoryV1InternalPdpsPdpIdSetCategoryPost, ssoAuthorizeV1AuthSsoAuthorizeGet, ssoCallbackV1AuthSsoCallbackGet, ssoCheckV1AuthSsoCheckGet, startAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPost, unfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDelete, unfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDelete, updateExplorePdpV1ExplorePdpsExplorePdpIdPatch, updateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatch, updateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatch, updateImageGenPromptV1ImageGenPromptsPromptIdPatch, updateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatch, updateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatch, updateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPut, updateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPut, updateOrganizationV1OrganizationsOrgIdPut, updatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatch, updatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatch, updatePdpV1PortfoliosPortfolioIdPdpsPdpIdPut, updatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPut, updateQueryV1ExploreQueriesQueryIdPatch, updateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePut, uploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPost, uploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPost, uploadImageV1PortfoliosPortfolioIdAssetsImagesPost, uploadImageV1WorkspacesWorkspaceIdAssetsImagesPost, validateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePost } from '../sdk.gen';
import type { AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData, AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostError, AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostResponse, AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData, AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostError, AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostResponse, BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostData, BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostError, BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostResponse, BulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostData, BulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostError, BulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostResponse, BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostData, BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostError, BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostResponse, BulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostData, BulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostError, BulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostResponse, BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData, BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostError, BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostResponse, BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostData, BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostError, BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostResponse, BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostData, BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostError, BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostResponse, BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData, BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostError, BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostResponse, BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostData, BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostError, BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostResponse, ClassifyByTitleV1ProductCategoriesClassifyByTitlePostData, ClassifyByTitleV1ProductCategoriesClassifyByTitlePostError, ClassifyByTitleV1ProductCategoriesClassifyByTitlePostResponse, CompleteAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGetData, CompleteAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGetError, ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostData, ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostError, ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostResponse, ComplexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostData, ComplexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostError, ComplexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostResponse, CreateAnalyticsTokenV1AnalyticsAuthPostData, CreateAnalyticsTokenV1AnalyticsAuthPostResponse, CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostData, CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostError, CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostResponse, CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData, CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostError, CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostResponse, CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostData, CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostError, CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostResponse, CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostData, CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostError, CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostResponse, CreateExploreImageV1ExploreImagesPostData, CreateExploreImageV1ExploreImagesPostError, CreateExploreImageV1ExploreImagesPostResponse, CreateExplorePdpV1ExplorePdpsPostData, CreateExplorePdpV1ExplorePdpsPostError, CreateExplorePdpV1ExplorePdpsPostResponse, CreateIdeaForImageV1InternalImagesImageIdIdeasPostData, CreateIdeaForImageV1InternalImagesImageIdIdeasPostError, CreateIdeaForImageV1InternalImagesImageIdIdeasPostResponse, CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData, CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostError, CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostResponse, CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostData, CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostError, CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostResponse, CreateImageClassificationV1AssetsImagesImageIdClassificationPostData, CreateImageClassificationV1AssetsImagesImageIdClassificationPostError, CreateImageClassificationV1AssetsImagesImageIdClassificationPostResponse, CreateImageScoreV1AssetsImagesImageIdRawScorePostData, CreateImageScoreV1AssetsImagesImageIdRawScorePostError, CreateImageScoreV1AssetsImagesImageIdRawScorePostResponse, CreateMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostData, CreateMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostError, CreateMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostResponse, CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData, CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostError, CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostResponse, CreateOrganizationV1OrganizationsPostData, CreateOrganizationV1OrganizationsPostError, CreateOrganizationV1OrganizationsPostResponse, CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData, CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostError, CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostResponse, CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostData, CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostError, CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostResponse, CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostData, CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostError, CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostResponse, CreatePdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostData, CreatePdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostError, CreatePdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostResponse, CreatePdpV1PortfoliosPortfolioIdPdpsPostData, CreatePdpV1PortfoliosPortfolioIdPdpsPostError, CreatePdpV1PortfoliosPortfolioIdPdpsPostResponse, CreatePdpV1WorkspacesWorkspaceIdPdpsPostData, CreatePdpV1WorkspacesWorkspaceIdPdpsPostError, CreatePdpV1WorkspacesWorkspaceIdPdpsPostResponse, CreateQueryV1ExploreQueriesPostData, CreateQueryV1ExploreQueriesPostError, CreateQueryV1ExploreQueriesPostResponse, CreateRoleAssignmentV1RoleAssignmentsPostData, CreateRoleAssignmentV1RoleAssignmentsPostError, CreateRoleAssignmentV1RoleAssignmentsPostResponse, CreateScoringResultsV1InternalImagesImageIdScoringResultsPostData, CreateScoringResultsV1InternalImagesImageIdScoringResultsPostError, CreateScoringResultsV1InternalImagesImageIdScoringResultsPostResponse, CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData, CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostError, CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostResponse, CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostData, CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostError, CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostResponse, DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData, DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteError, DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteResponse, DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteData, DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteError, DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteResponse, DeleteExploreImageV1ExploreImagesExploreImageIdDeleteData, DeleteExploreImageV1ExploreImagesExploreImageIdDeleteError, DeleteExploreImageV1ExploreImagesExploreImageIdDeleteResponse, DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData, DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError, DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse, DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData, DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError, DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse, DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteData, DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteError, DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteResponse, DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData, DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteError, DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteResponse, DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteData, DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteError, DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteResponse, DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData, DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteError, DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteResponse, DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData, DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteError, DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteResponse, DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteData, DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteError, DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteResponse, DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData, DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteError, DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteResponse, DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteData, DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteError, DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteResponse, DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteData, DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteError, DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteResponse, DeleteUserV1UsersUserIdDeleteData, DeleteUserV1UsersUserIdDeleteError, DeleteUserV1UsersUserIdDeleteResponse, DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteData, DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteError, DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteResponse, DownloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetData, DownloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetError, DownloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetResponse, DownloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetData, DownloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetError, DownloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetResponse, ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData, ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostError, ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostResponse, ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetData, ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetError, ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetResponse, ExportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetData, ExportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetError, ExportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetResponse, FavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutData, FavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutError, FavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutResponse, FavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutData, FavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutError, FavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutResponse, FindIntegrationV1IntegrationsGetData, FindIntegrationV1IntegrationsGetError, FindIntegrationV1IntegrationsGetResponse, GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData, GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostError, GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostResponse, GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetData, GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetError, GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetResponse, GetArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetData, GetArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetError, GetArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetResponse, GetAudienceV1AudiencesAudienceIdGetData, GetAudienceV1AudiencesAudienceIdGetError, GetAudienceV1AudiencesAudienceIdGetResponse, GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetData, GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetError, GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetResponse, GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData, GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetError, GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponse, GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetData, GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetError, GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetResponse, GetBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetData, GetBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetError, GetBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetResponse, GetBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetData, GetBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetError, GetBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetResponse, GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetData, GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetError, GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetResponse, GetBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetData, GetBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetError, GetBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetResponse, GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetData, GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetError, GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetResponse, GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetData, GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetError, GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetResponse, GetCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetData, GetCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetError, GetCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetResponse, GetCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetData, GetCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetError, GetCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetResponse, GetCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetData, GetCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetError, GetCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetResponse, GetDispatchContextV1InternalImagesImageIdDispatchContextGetData, GetDispatchContextV1InternalImagesImageIdDispatchContextGetError, GetDispatchContextV1InternalImagesImageIdDispatchContextGetResponse, GetExploreImageV1ExploreImagesExploreImageIdGetData, GetExploreImageV1ExploreImagesExploreImageIdGetError, GetExploreImageV1ExploreImagesExploreImageIdGetResponse, GetExplorePdpV1ExplorePdpsExplorePdpIdGetData, GetExplorePdpV1ExplorePdpsExplorePdpIdGetError, GetExplorePdpV1ExplorePdpsExplorePdpIdGetResponse, GetFeatureFlagV1FeatureFlagsFlagGetData, GetFeatureFlagV1FeatureFlagsFlagGetError, GetFeatureFlagV1FeatureFlagsFlagGetResponse, GetFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetData, GetFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetError, GetFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetResponse, GetIcpProductCategoriesV1IcpProductCategoriesGetData, GetIcpProductCategoriesV1IcpProductCategoriesGetError, GetIcpProductCategoriesV1IcpProductCategoriesGetResponse, GetIcpProductCategoriesV1L1ProductCategoriesGetData, GetIcpProductCategoriesV1L1ProductCategoriesGetError, GetIcpProductCategoriesV1L1ProductCategoriesGetResponse, GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetData, GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetError, GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetResponse, GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetData, GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetError, GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetResponse, GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetData, GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetError, GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetResponse, GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetData, GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetError, GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetResponse, GetImageByIdV1ImagesImageIdGetData, GetImageByIdV1ImagesImageIdGetError, GetImageByIdV1ImagesImageIdGetResponse, GetImageClassificationV1ExploreClassificationsClassificationIdGetData, GetImageClassificationV1ExploreClassificationsClassificationIdGetError, GetImageClassificationV1ExploreClassificationsClassificationIdGetResponse, GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetData, GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetError, GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetResponse, GetImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetData, GetImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetError, GetImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetResponse, GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData, GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetError, GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponse, GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData, GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetError, GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponse, GetImageGenPromptV1ImageGenPromptsPromptIdGetData, GetImageGenPromptV1ImageGenPromptsPromptIdGetError, GetImageGenPromptV1ImageGenPromptsPromptIdGetResponse, GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetData, GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetError, GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetResponse, GetImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetData, GetImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetError, GetImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetResponse, GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetData, GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetError, GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetResponse, GetImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetData, GetImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetError, GetImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetResponse, GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetData, GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetError, GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetResponse, GetImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetData, GetImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetError, GetImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetResponse, GetImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetData, GetImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetError, GetImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetResponse, GetImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetData, GetImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetError, GetImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetResponse, GetImagesScoringDataV1InternalImagesScoringDataGetData, GetImagesScoringDataV1InternalImagesScoringDataGetError, GetImagesScoringDataV1InternalImagesScoringDataGetResponse, GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetData, GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetError, GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetResponse, GetImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetData, GetImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetError, GetImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetResponse, GetIntegrationV1IntegrationsIntegrationIdGetData, GetIntegrationV1IntegrationsIntegrationIdGetError, GetIntegrationV1IntegrationsIntegrationIdGetResponse, GetMeV1MeGetData, GetMeV1MeGetResponse, GetOrganizationNameV1InternalOrganizationsOrgIdNameGetData, GetOrganizationNameV1InternalOrganizationsOrgIdNameGetError, GetOrganizationNameV1InternalOrganizationsOrgIdNameGetResponse, GetOrganizationsForUserV1UsersUserIdOrganizationsGetData, GetOrganizationsForUserV1UsersUserIdOrganizationsGetError, GetOrganizationsForUserV1UsersUserIdOrganizationsGetResponse, GetOrganizationV1OrganizationsOrgIdGetData, GetOrganizationV1OrganizationsOrgIdGetError, GetOrganizationV1OrganizationsOrgIdGetResponse, GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetData, GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetError, GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetResponse, GetOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetData, GetOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetError, GetOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetResponse, GetPdpScoringContextV1InternalPdpsPdpIdScoringContextGetData, GetPdpScoringContextV1InternalPdpsPdpIdScoringContextGetError, GetPdpScoringContextV1InternalPdpsPdpIdScoringContextGetResponse, GetPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetData, GetPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetError, GetPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetResponse, GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetData, GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetError, GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetResponse, GetPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetData, GetPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetError, GetPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetResponse, GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData, GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetError, GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponse, GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetData, GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetError, GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetResponse, GetProductCategoriesV1ProductCategoriesGetData, GetProductCategoriesV1ProductCategoriesGetError, GetProductCategoriesV1ProductCategoriesGetResponse, GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetData, GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetError, GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetResponse, GetProductCategoryV1ProductCategoriesCategoryIdGetData, GetProductCategoryV1ProductCategoriesCategoryIdGetError, GetProductCategoryV1ProductCategoriesCategoryIdGetResponse, GetQueryV1ExploreQueriesQueryIdGetData, GetQueryV1ExploreQueriesQueryIdGetError, GetQueryV1ExploreQueriesQueryIdGetResponse, GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetData, GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetError, GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetResponse, GetRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetData, GetRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetError, GetRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetResponse, GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetData, GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetError, GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetResponse, GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetData, GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetError, GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetResponse, GetScrapedPdpV1PdpsRequestIdGetData, GetScrapedPdpV1PdpsRequestIdGetError, GetScrapedPdpV1PdpsRequestIdGetResponse, GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData, GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetError, GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponse, GetUserV1UsersUserIdGetData, GetUserV1UsersUserIdGetError, GetUserV1UsersUserIdGetResponse, GetWorkspaceBySlugV1WorkspacesBySlugSlugGetData, GetWorkspaceBySlugV1WorkspacesBySlugSlugGetError, GetWorkspaceBySlugV1WorkspacesBySlugSlugGetResponse, HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostData, HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostError, HealthcheckGetData, HealthcheckGetResponse, HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetResponse, ListActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGetData, ListActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGetResponse, ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetData, ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetError, ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetResponse, ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData, ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetError, ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponse, ListCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetData, ListCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetError, ListCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetResponse, ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetData, ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetError, ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetResponse, ListExploreImagesV1ExploreImagesGetData, ListExploreImagesV1ExploreImagesGetError, ListExploreImagesV1ExploreImagesGetResponse, ListFeatureFlagsV1FeatureFlagsGetData, ListFeatureFlagsV1FeatureFlagsGetResponse, ListImageClassificationsV1ExploreClassificationsGetData, ListImageClassificationsV1ExploreClassificationsGetResponse, ListRetailerRegionsV1RetailerRegionsGetData, ListRetailerRegionsV1RetailerRegionsGetError, ListRetailerRegionsV1RetailerRegionsGetResponse, LoginUserV1UsersAuthenticatePostData, LoginUserV1UsersAuthenticatePostError, LoginUserV1UsersAuthenticatePostResponse, LogoutUserV1UsersUserIdLogoutPostData, LogoutUserV1UsersUserIdLogoutPostError, LookupCategoriesV1InternalProductCategoriesLookupGetData, LookupCategoriesV1InternalProductCategoriesLookupGetError, LookupCategoriesV1InternalProductCategoriesLookupGetResponse, LookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostData, LookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostError, LookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostResponse, PostProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostData, PostProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostError, PostProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostResponse, PostScoringCompleteV1InternalPdpsPdpIdScoringCompletePostData, PostScoringCompleteV1InternalPdpsPdpIdScoringCompletePostError, PostScoringCompleteV1InternalPdpsPdpIdScoringCompletePostResponse, ProcessBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostData, ProcessBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostError, ProcessBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostResponse, ReadyReadyGetData, ReadyReadyGetResponse, ReconcileStaleBulkInvitesV1BulkInviteReconcileStalePostData, ReconcileStaleBulkInvitesV1BulkInviteReconcileStalePostResponse, RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData, RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostError, RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostData, RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostError, RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData, RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteError, RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteResponse, RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData, RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteError, RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteResponse, RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData, RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchError, RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchResponse, RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchData, RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchError, RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchResponse, ReplaceExploreImageV1ExploreImagesExploreImageIdPutData, ReplaceExploreImageV1ExploreImagesExploreImageIdPutError, ReplaceExploreImageV1ExploreImagesExploreImageIdPutResponse, ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData, ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostError, ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostResponse, ResetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostData, ResetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostError, ResetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostResponse, ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostData, ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostError, ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostResponse, ResetPasswordV1UsersPasswordPutData, ResetPasswordV1UsersPasswordPutError, ScrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostData, ScrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostError, ScrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostResponse, SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData, SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetError, SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponse, SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetData, SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetError, SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetResponse, SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData, SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetError, SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponse, SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetData, SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetError, SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetResponse, SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData, SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetError, SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponse, SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetData, SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetError, SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetResponse, SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData, SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetError, SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponse, SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetData, SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetError, SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetResponse, SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData, SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetError, SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponse, SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetData, SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetError, SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetResponse, SearchPdpsV1PortfoliosPortfolioIdPdpsGetData, SearchPdpsV1PortfoliosPortfolioIdPdpsGetError, SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponse, SearchPdpsV1WorkspacesWorkspaceIdPdpsGetData, SearchPdpsV1WorkspacesWorkspaceIdPdpsGetError, SearchPdpsV1WorkspacesWorkspaceIdPdpsGetResponse, SearchRoleAssignmentsV1RoleAssignmentsGetData, SearchRoleAssignmentsV1RoleAssignmentsGetError, SearchRoleAssignmentsV1RoleAssignmentsGetResponse, SetPasswordV1UsersUserIdPasswordPostData, SetPasswordV1UsersUserIdPasswordPostError, SetPasswordV1UsersUserIdPasswordPostResponse, SetPdpCategoryV1InternalPdpsPdpIdSetCategoryPostData, SetPdpCategoryV1InternalPdpsPdpIdSetCategoryPostError, SetPdpCategoryV1InternalPdpsPdpIdSetCategoryPostResponse, SsoAuthorizeV1AuthSsoAuthorizeGetData, SsoAuthorizeV1AuthSsoAuthorizeGetError, SsoAuthorizeV1AuthSsoAuthorizeGetResponse, SsoCallbackV1AuthSsoCallbackGetData, SsoCallbackV1AuthSsoCallbackGetError, SsoCheckV1AuthSsoCheckGetData, SsoCheckV1AuthSsoCheckGetError, SsoCheckV1AuthSsoCheckGetResponse, StartAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPostData, StartAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPostResponse, UnfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteData, UnfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteError, UnfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteResponse, UnfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteData, UnfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteError, UnfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteResponse, UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchData, UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchError, UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchResponse, UpdateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchData, UpdateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchError, UpdateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchResponse, UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchData, UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchError, UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchResponse, UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchData, UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchError, UpdateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchData, UpdateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchError, UpdateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchResponse, UpdateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchData, UpdateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchError, UpdateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchResponse, UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutData, UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutError, UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutResponse, UpdateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutData, UpdateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutError, UpdateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutResponse, UpdateOrganizationV1OrganizationsOrgIdPutData, UpdateOrganizationV1OrganizationsOrgIdPutError, UpdateOrganizationV1OrganizationsOrgIdPutResponse, UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData, UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchError, UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchResponse, UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchData, UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchError, UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchResponse, UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData, UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutError, UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutResponse, UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutData, UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutError, UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutResponse, UpdateQueryV1ExploreQueriesQueryIdPatchData, UpdateQueryV1ExploreQueriesQueryIdPatchError, UpdateQueryV1ExploreQueriesQueryIdPatchResponse, UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutData, UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutError, UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutResponse, UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData, UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostError, UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostResponse, UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostData, UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostError, UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostResponse, UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData, UploadImageV1PortfoliosPortfolioIdAssetsImagesPostError, UploadImageV1PortfoliosPortfolioIdAssetsImagesPostResponse, UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostData, UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostError, UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostResponse, ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostData, ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostError, ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostResponse } from '../types.gen';

/**
 * Create Analytics Token
 *
 * Mints a short-lived JWT the browser presents to Cube. The organization comes from the session, so a caller cannot scope the token to another organization.
 */
export const createAnalyticsTokenV1AnalyticsAuthPostMutation = (options?: Partial<Options<CreateAnalyticsTokenV1AnalyticsAuthPostData>>): UseMutationOptions<CreateAnalyticsTokenV1AnalyticsAuthPostResponse, DefaultError, Options<CreateAnalyticsTokenV1AnalyticsAuthPostData>> => {
    const mutationOptions: UseMutationOptions<CreateAnalyticsTokenV1AnalyticsAuthPostResponse, DefaultError, Options<CreateAnalyticsTokenV1AnalyticsAuthPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAnalyticsTokenV1AnalyticsAuthPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const ssoCheckV1AuthSsoCheckGetQueryKey = (options: Options<SsoCheckV1AuthSsoCheckGetData>) => createQueryKey('ssoCheckV1AuthSsoCheckGet', options);

/**
 * Sso Check
 */
export const ssoCheckV1AuthSsoCheckGetOptions = (options: Options<SsoCheckV1AuthSsoCheckGetData>) => queryOptions<SsoCheckV1AuthSsoCheckGetResponse, SsoCheckV1AuthSsoCheckGetError, SsoCheckV1AuthSsoCheckGetResponse, ReturnType<typeof ssoCheckV1AuthSsoCheckGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ssoCheckV1AuthSsoCheckGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ssoCheckV1AuthSsoCheckGetQueryKey(options)
});

export const ssoAuthorizeV1AuthSsoAuthorizeGetQueryKey = (options: Options<SsoAuthorizeV1AuthSsoAuthorizeGetData>) => createQueryKey('ssoAuthorizeV1AuthSsoAuthorizeGet', options);

/**
 * Sso Authorize
 */
export const ssoAuthorizeV1AuthSsoAuthorizeGetOptions = (options: Options<SsoAuthorizeV1AuthSsoAuthorizeGetData>) => queryOptions<SsoAuthorizeV1AuthSsoAuthorizeGetResponse, SsoAuthorizeV1AuthSsoAuthorizeGetError, SsoAuthorizeV1AuthSsoAuthorizeGetResponse, ReturnType<typeof ssoAuthorizeV1AuthSsoAuthorizeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ssoAuthorizeV1AuthSsoAuthorizeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ssoAuthorizeV1AuthSsoAuthorizeGetQueryKey(options)
});

export const ssoCallbackV1AuthSsoCallbackGetQueryKey = (options?: Options<SsoCallbackV1AuthSsoCallbackGetData>) => createQueryKey('ssoCallbackV1AuthSsoCallbackGet', options);

/**
 * Sso Callback
 */
export const ssoCallbackV1AuthSsoCallbackGetOptions = (options?: Options<SsoCallbackV1AuthSsoCallbackGetData>) => queryOptions<unknown, SsoCallbackV1AuthSsoCallbackGetError, unknown, ReturnType<typeof ssoCallbackV1AuthSsoCallbackGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ssoCallbackV1AuthSsoCallbackGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ssoCallbackV1AuthSsoCallbackGetQueryKey(options)
});

export const getAudienceV1AudiencesAudienceIdGetQueryKey = (options: Options<GetAudienceV1AudiencesAudienceIdGetData>) => createQueryKey('getAudienceV1AudiencesAudienceIdGet', options);

/**
 * Get Audience
 */
export const getAudienceV1AudiencesAudienceIdGetOptions = (options: Options<GetAudienceV1AudiencesAudienceIdGetData>) => queryOptions<GetAudienceV1AudiencesAudienceIdGetResponse, GetAudienceV1AudiencesAudienceIdGetError, GetAudienceV1AudiencesAudienceIdGetResponse, ReturnType<typeof getAudienceV1AudiencesAudienceIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAudienceV1AudiencesAudienceIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAudienceV1AudiencesAudienceIdGetQueryKey(options)
});

export const getArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetQueryKey = (options: Options<GetArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetData>) => createQueryKey('getArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGet', options);

/**
 * Get Artifact
 *
 * Returns a signed URL to an image's artifact
 */
export const getArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetOptions = (options: Options<GetArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetData>) => queryOptions<GetArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetResponse, GetArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetError, GetArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetResponse, ReturnType<typeof getArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getArtifactV1WorkspacesWorkspaceIdAssetsImagesImageIdArtifactsArtifactTypeGetQueryKey(options)
});

export const getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetQueryKey = (options: Options<GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetData>) => createQueryKey('getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGet', options);

/**
 * Get Artifact
 *
 * Returns a signed URL to an image's artifact
 */
export const getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetOptions = (options: Options<GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetData>) => queryOptions<GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetResponse, GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetError, GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetResponse, ReturnType<typeof getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetQueryKey(options)
});

export const listActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGetQueryKey = (options?: Options<ListActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGetData>) => createQueryKey('listActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGet', options);

/**
 * List Active Amazon Vendor Integrations
 */
export const listActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGetOptions = (options?: Options<ListActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGetData>) => queryOptions<ListActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGetResponse, DefaultError, ListActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGetResponse, ReturnType<typeof listActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listActiveAmazonVendorIntegrationsV1InternalAmazonVendorIntegrationsGetQueryKey(options)
});

export const getBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetQueryKey = (options: Options<GetBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetData>) => createQueryKey('getBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGet', options);

/**
 * Get Bulk Refresh Job
 */
export const getBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetOptions = (options: Options<GetBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetData>) => queryOptions<GetBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetResponse, GetBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetError, GetBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetResponse, ReturnType<typeof getBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBulkRefreshJobV1WorkspacesWorkspaceIdBulkRefreshBulkRefreshIdGetQueryKey(options)
});

export const getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetQueryKey = (options: Options<GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetData>) => createQueryKey('getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGet', options);

/**
 * Get Bulk Refresh Job
 */
export const getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetOptions = (options: Options<GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetData>) => queryOptions<GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetResponse, GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetError, GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetResponse, ReturnType<typeof getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetQueryKey(options)
});

/**
 * Bulk Refresh Pdps
 */
export const bulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostMutation = (options?: Partial<Options<BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostData>>): UseMutationOptions<BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostResponse, BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostError, Options<BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostData>> => {
    const mutationOptions: UseMutationOptions<BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostResponse, BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostError, Options<BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Refresh Pdps
 */
export const bulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostMutation = (options?: Partial<Options<BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData>>): UseMutationOptions<BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostResponse, BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostError, Options<BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData>> => {
    const mutationOptions: UseMutationOptions<BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostResponse, BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostError, Options<BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Import Csv
 *
 * Bulk imports PDPs from a CSV file containing item IDs, retailer, and region.
 *
 * Accepts a CSV file with 3 columns:
 * - Column 1: Item ID (format depends on retailer; for Amazon, this is an ASIN)
 * - Column 2: Retailer (e.g., "amazon")
 * - Column 3: Region (e.g., "us")
 *
 * Returns:
 * BulkImportResponse with bulk import ID, message, and counts
 *
 * Raises:
 * 400: Invalid file format, size, row count, missing retailer/region, or unsupported retailer
 * 429: Rate limit exceeded (1 import per minute per user)
 * 500: Internal server errors
 */
export const bulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostMutation = (options?: Partial<Options<BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostData>>): UseMutationOptions<BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostResponse, BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostError, Options<BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostData>> => {
    const mutationOptions: UseMutationOptions<BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostResponse, BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostError, Options<BulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkImportCsvV1WorkspacesWorkspaceIdBulkImportCsvPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Import Csv
 *
 * Bulk imports PDPs from a CSV file containing item IDs, retailer, and region.
 *
 * Accepts a CSV file with 3 columns:
 * - Column 1: Item ID (format depends on retailer; for Amazon, this is an ASIN)
 * - Column 2: Retailer (e.g., "amazon")
 * - Column 3: Region (e.g., "us")
 *
 * Returns:
 * BulkImportResponse with bulk import ID, message, and counts
 *
 * Raises:
 * 400: Invalid file format, size, row count, missing retailer/region, or unsupported retailer
 * 429: Rate limit exceeded (1 import per minute per user)
 * 500: Internal server errors
 */
export const bulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostMutation = (options?: Partial<Options<BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData>>): UseMutationOptions<BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostResponse, BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostError, Options<BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData>> => {
    const mutationOptions: UseMutationOptions<BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostResponse, BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostError, Options<BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetQueryKey = (options: Options<GetBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetData>) => createQueryKey('getBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGet', options);

/**
 * Get Bulk Import
 *
 * Get status and details of a bulk import job.
 *
 * Returns:
 * BulkImportView with import status, counts, and completion information
 */
export const getBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetOptions = (options: Options<GetBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetData>) => queryOptions<GetBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetResponse, GetBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetError, GetBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetResponse, ReturnType<typeof getBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBulkImportV1WorkspacesWorkspaceIdBulkImportBulkImportIdGetQueryKey(options)
});

export const getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetQueryKey = (options: Options<GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetData>) => createQueryKey('getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGet', options);

/**
 * Get Bulk Import
 *
 * Get status and details of a bulk import job.
 *
 * Returns:
 * BulkImportView with import status, counts, and completion information
 */
export const getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetOptions = (options: Options<GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetData>) => queryOptions<GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetResponse, GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetError, GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetResponse, ReturnType<typeof getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetQueryKey(options)
});

/**
 * Bulk Invite Csv
 *
 * Dispatch bulk user invites from a CSV of email addresses (single Email
 * column), optionally carrying one batch-level role and scope grant.
 */
export const bulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostMutation = (options?: Partial<Options<BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostData>>): UseMutationOptions<BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostResponse, BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostError, Options<BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostData>> => {
    const mutationOptions: UseMutationOptions<BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostResponse, BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostError, Options<BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate Bulk Invite
 *
 * Dry-run per-email validation powering the FE inline preview. No side
 * effects; grant fields go through the same checks dispatch runs.
 */
export const validateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostMutation = (options?: Partial<Options<ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostData>>): UseMutationOptions<ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostResponse, ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostError, Options<ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostData>> => {
    const mutationOptions: UseMutationOptions<ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostResponse, ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostError, Options<ValidateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteValidatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetQueryKey = (options: Options<GetBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetData>) => createQueryKey('getBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGet', options);

/**
 * Get Bulk Invite
 *
 * Poll a bulk-invite job's status and counters.
 */
export const getBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetOptions = (options: Options<GetBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetData>) => queryOptions<GetBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetResponse, GetBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetError, GetBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetResponse, ReturnType<typeof getBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBulkInviteV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdGetQueryKey(options)
});

/**
 * Process Bulk Invite Email
 *
 * Process a single queued invite. Machine-only callback for the SQS worker.
 */
export const processBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostMutation = (options?: Partial<Options<ProcessBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostData>>): UseMutationOptions<ProcessBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostResponse, ProcessBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostError, Options<ProcessBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostData>> => {
    const mutationOptions: UseMutationOptions<ProcessBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostResponse, ProcessBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostError, Options<ProcessBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processBulkInviteEmailV1OrganizationsOrganizationIdUsersBulkInviteBulkInviteIdProcessPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reconcile Stale Bulk Invites
 *
 * Reap jobs stuck PROCESSING past the stale window and fire their completion
 * emails. Machine-only: the scheduled sweeper calls this because the FE never
 * polls the per-job status endpoint that otherwise runs the reaper.
 */
export const reconcileStaleBulkInvitesV1BulkInviteReconcileStalePostMutation = (options?: Partial<Options<ReconcileStaleBulkInvitesV1BulkInviteReconcileStalePostData>>): UseMutationOptions<ReconcileStaleBulkInvitesV1BulkInviteReconcileStalePostResponse, DefaultError, Options<ReconcileStaleBulkInvitesV1BulkInviteReconcileStalePostData>> => {
    const mutationOptions: UseMutationOptions<ReconcileStaleBulkInvitesV1BulkInviteReconcileStalePostResponse, DefaultError, Options<ReconcileStaleBulkInvitesV1BulkInviteReconcileStalePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reconcileStaleBulkInvitesV1BulkInviteReconcileStalePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetQueryKey = (options: Options<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetData>) => createQueryKey('searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGet', options);

/**
 * Search Collections
 */
export const searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetOptions = (options: Options<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetData>) => queryOptions<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetResponse, SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetError, SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetResponse, ReturnType<typeof searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetInfiniteQueryKey = (options: Options<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetData>): QueryKey<Options<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetData>> => createQueryKey('searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGet', options, true);

/**
 * Search Collections
 */
export const searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetInfiniteOptions = (options: Options<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetData>) => infiniteQueryOptions<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetResponse, SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetError, InfiniteData<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetResponse>, QueryKey<Options<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetData>>, number | Pick<QueryKey<Options<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchCollectionsV1WorkspacesWorkspaceIdAssetsImagesCollectionsGetInfiniteQueryKey(options)
});

/**
 * Create Collection
 */
export const createCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostMutation = (options?: Partial<Options<CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostData>>): UseMutationOptions<CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostResponse, CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostError, Options<CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostResponse, CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostError, Options<CreateCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetQueryKey = (options: Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>) => createQueryKey('searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet', options);

/**
 * Search Collections
 */
export const searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetOptions = (options: Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>) => queryOptions<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponse, SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetError, SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponse, ReturnType<typeof searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetQueryKey(options)
});

export const searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetInfiniteQueryKey = (options: Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>): QueryKey<Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>> => createQueryKey('searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet', options, true);

/**
 * Search Collections
 */
export const searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetInfiniteOptions = (options: Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>) => infiniteQueryOptions<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponse, SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetError, InfiniteData<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponse>, QueryKey<Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>>, number | Pick<QueryKey<Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetInfiniteQueryKey(options)
});

/**
 * Create Collection
 */
export const createCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostMutation = (options?: Partial<Options<CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData>>): UseMutationOptions<CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostResponse, CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostError, Options<CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostResponse, CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostError, Options<CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Collection
 *
 * Delete a collection and all its images.
 */
export const deleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteMutation = (options?: Partial<Options<DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteData>>): UseMutationOptions<DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteResponse, DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteError, Options<DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteResponse, DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteError, Options<DeleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetQueryKey = (options: Options<GetCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetData>) => createQueryKey('getCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGet', options);

/**
 * Get Collection
 */
export const getCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetOptions = (options: Options<GetCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetData>) => queryOptions<GetCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetResponse, GetCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetError, GetCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetResponse, ReturnType<typeof getCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdGetQueryKey(options)
});

/**
 * Rename Collection
 *
 * Rename a collection.
 */
export const renameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchMutation = (options?: Partial<Options<RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchData>>): UseMutationOptions<RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchResponse, RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchError, Options<RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchData>> => {
    const mutationOptions: UseMutationOptions<RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchResponse, RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchError, Options<RenameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await renameCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Collection
 *
 * Delete a collection and all its images.
 */
export const deleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteMutation = (options?: Partial<Options<DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData>>): UseMutationOptions<DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteResponse, DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteError, Options<DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteResponse, DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteError, Options<DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetQueryKey = (options: Options<GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetData>) => createQueryKey('getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGet', options);

/**
 * Get Collection
 */
export const getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetOptions = (options: Options<GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetData>) => queryOptions<GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetResponse, GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetError, GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetResponse, ReturnType<typeof getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetQueryKey(options)
});

/**
 * Rename Collection
 *
 * Rename a collection.
 */
export const renameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchMutation = (options?: Partial<Options<RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData>>): UseMutationOptions<RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchResponse, RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchError, Options<RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData>> => {
    const mutationOptions: UseMutationOptions<RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchResponse, RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchError, Options<RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await renameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Image From Collection
 *
 * Delete a single image from a collection.
 */
export const deleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteMutation = (options?: Partial<Options<DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData>>): UseMutationOptions<DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse, DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError, Options<DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse, DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError, Options<DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Image From Collection
 *
 * Delete a single image from a collection.
 */
export const deleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteMutation = (options?: Partial<Options<DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData>>): UseMutationOptions<DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse, DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError, Options<DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse, DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError, Options<DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetQueryKey = (options: Options<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetData>) => createQueryKey('searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGet', options);

/**
 * Search Collection Images
 *
 * Retrieves images within a collection with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID to find children of a specific parent
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - classification: Include only images with these asset classifications
 */
export const searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetOptions = (options: Options<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetData>) => queryOptions<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetResponse, SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetError, SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetResponse, ReturnType<typeof searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetQueryKey(options)
});

export const searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetInfiniteQueryKey = (options: Options<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetData>): QueryKey<Options<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetData>> => createQueryKey('searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGet', options, true);

/**
 * Search Collection Images
 *
 * Retrieves images within a collection with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID to find children of a specific parent
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - classification: Include only images with these asset classifications
 */
export const searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetInfiniteOptions = (options: Options<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetData>) => infiniteQueryOptions<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetResponse, SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetError, InfiniteData<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetResponse>, QueryKey<Options<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetData>>, number | Pick<QueryKey<Options<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchCollectionImagesV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesGetInfiniteQueryKey(options)
});

/**
 * Upload Image To Collection
 */
export const uploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostMutation = (options?: Partial<Options<UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostData>>): UseMutationOptions<UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostResponse, UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostError, Options<UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostData>> => {
    const mutationOptions: UseMutationOptions<UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostResponse, UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostError, Options<UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetQueryKey = (options: Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>) => createQueryKey('searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet', options);

/**
 * Search Collection Images
 *
 * Retrieves images within a collection with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID to find children of a specific parent
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - classification: Include only images with these asset classifications
 */
export const searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetOptions = (options: Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>) => queryOptions<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponse, SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetError, SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponse, ReturnType<typeof searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetQueryKey(options)
});

export const searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetInfiniteQueryKey = (options: Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>): QueryKey<Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>> => createQueryKey('searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet', options, true);

/**
 * Search Collection Images
 *
 * Retrieves images within a collection with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID to find children of a specific parent
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - classification: Include only images with these asset classifications
 */
export const searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetInfiniteOptions = (options: Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>) => infiniteQueryOptions<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponse, SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetError, InfiniteData<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponse>, QueryKey<Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>>, number | Pick<QueryKey<Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetInfiniteQueryKey(options)
});

/**
 * Upload Image To Collection
 */
export const uploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostMutation = (options?: Partial<Options<UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData>>): UseMutationOptions<UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostResponse, UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostError, Options<UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData>> => {
    const mutationOptions: UseMutationOptions<UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostResponse, UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostError, Options<UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetQueryKey = (options: Options<ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetData>) => createQueryKey('listCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGet', options);

/**
 * List Collection Image Classifications
 *
 * Asset classifications present on a collection's images, for the filter picker.
 */
export const listCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetOptions = (options: Options<ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetData>) => queryOptions<ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetResponse, ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetError, ListCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetResponse, ReturnType<typeof listCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCollectionImageClassificationsV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImageClassificationsGetQueryKey(options)
});

export const listCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetQueryKey = (options: Options<ListCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetData>) => createQueryKey('listCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGet', options);

/**
 * List Collection Image Classifications
 *
 * Asset classifications present on a collection's images, for the filter picker.
 */
export const listCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetOptions = (options: Options<ListCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetData>) => queryOptions<ListCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetResponse, ListCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetError, ListCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetResponse, ReturnType<typeof listCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCollectionImageClassificationsV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImageClassificationsGetQueryKey(options)
});

export const getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetQueryKey = (options: Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>) => createQueryKey('getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet', options);

/**
 * Get Benchmark Images
 *
 * Retrieves the benchmark images for a product category
 */
export const getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetOptions = (options: Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>) => queryOptions<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponse, GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetError, GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponse, ReturnType<typeof getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetQueryKey(options)
});

export const getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetInfiniteQueryKey = (options: Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>): QueryKey<Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>> => createQueryKey('getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet', options, true);

/**
 * Get Benchmark Images
 *
 * Retrieves the benchmark images for a product category
 */
export const getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetInfiniteOptions = (options: Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>) => infiniteQueryOptions<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponse, GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetError, InfiniteData<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponse>, QueryKey<Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>>, number | Pick<QueryKey<Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetInfiniteQueryKey(options)
});

export const getFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetQueryKey = (options: Options<GetFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetData>) => createQueryKey('getFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGet', options);

/**
 * Get Fixed Effects Benchmark Images
 */
export const getFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetOptions = (options: Options<GetFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetData>) => queryOptions<GetFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetResponse, GetFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetError, GetFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetResponse, ReturnType<typeof getFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFixedEffectsBenchmarkImagesV1ProductCategoriesProductCategoryIdFixedEffectsBenchmarkImagesGetQueryKey(options)
});

export const listExploreImagesV1ExploreImagesGetQueryKey = (options?: Options<ListExploreImagesV1ExploreImagesGetData>) => createQueryKey('listExploreImagesV1ExploreImagesGet', options);

/**
 * List Explore Images
 *
 * List ExploreImage records with optional filters for idempotency checks.
 */
export const listExploreImagesV1ExploreImagesGetOptions = (options?: Options<ListExploreImagesV1ExploreImagesGetData>) => queryOptions<ListExploreImagesV1ExploreImagesGetResponse, ListExploreImagesV1ExploreImagesGetError, ListExploreImagesV1ExploreImagesGetResponse, ReturnType<typeof listExploreImagesV1ExploreImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExploreImagesV1ExploreImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExploreImagesV1ExploreImagesGetQueryKey(options)
});

export const listExploreImagesV1ExploreImagesGetInfiniteQueryKey = (options?: Options<ListExploreImagesV1ExploreImagesGetData>): QueryKey<Options<ListExploreImagesV1ExploreImagesGetData>> => createQueryKey('listExploreImagesV1ExploreImagesGet', options, true);

/**
 * List Explore Images
 *
 * List ExploreImage records with optional filters for idempotency checks.
 */
export const listExploreImagesV1ExploreImagesGetInfiniteOptions = (options?: Options<ListExploreImagesV1ExploreImagesGetData>) => infiniteQueryOptions<ListExploreImagesV1ExploreImagesGetResponse, ListExploreImagesV1ExploreImagesGetError, InfiniteData<ListExploreImagesV1ExploreImagesGetResponse>, QueryKey<Options<ListExploreImagesV1ExploreImagesGetData>>, number | Pick<QueryKey<Options<ListExploreImagesV1ExploreImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListExploreImagesV1ExploreImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listExploreImagesV1ExploreImagesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExploreImagesV1ExploreImagesGetInfiniteQueryKey(options)
});

/**
 * Create Explore Image
 *
 * Create a new ExploreImage record for explore functionality.
 */
export const createExploreImageV1ExploreImagesPostMutation = (options?: Partial<Options<CreateExploreImageV1ExploreImagesPostData>>): UseMutationOptions<CreateExploreImageV1ExploreImagesPostResponse, CreateExploreImageV1ExploreImagesPostError, Options<CreateExploreImageV1ExploreImagesPostData>> => {
    const mutationOptions: UseMutationOptions<CreateExploreImageV1ExploreImagesPostResponse, CreateExploreImageV1ExploreImagesPostError, Options<CreateExploreImageV1ExploreImagesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createExploreImageV1ExploreImagesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Explore Image
 *
 * Delete an ExploreImage record.
 */
export const deleteExploreImageV1ExploreImagesExploreImageIdDeleteMutation = (options?: Partial<Options<DeleteExploreImageV1ExploreImagesExploreImageIdDeleteData>>): UseMutationOptions<DeleteExploreImageV1ExploreImagesExploreImageIdDeleteResponse, DeleteExploreImageV1ExploreImagesExploreImageIdDeleteError, Options<DeleteExploreImageV1ExploreImagesExploreImageIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteExploreImageV1ExploreImagesExploreImageIdDeleteResponse, DeleteExploreImageV1ExploreImagesExploreImageIdDeleteError, Options<DeleteExploreImageV1ExploreImagesExploreImageIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteExploreImageV1ExploreImagesExploreImageIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExploreImageV1ExploreImagesExploreImageIdGetQueryKey = (options: Options<GetExploreImageV1ExploreImagesExploreImageIdGetData>) => createQueryKey('getExploreImageV1ExploreImagesExploreImageIdGet', options);

/**
 * Get Explore Image
 *
 * Get a specific ExploreImage record by ID.
 */
export const getExploreImageV1ExploreImagesExploreImageIdGetOptions = (options: Options<GetExploreImageV1ExploreImagesExploreImageIdGetData>) => queryOptions<GetExploreImageV1ExploreImagesExploreImageIdGetResponse, GetExploreImageV1ExploreImagesExploreImageIdGetError, GetExploreImageV1ExploreImagesExploreImageIdGetResponse, ReturnType<typeof getExploreImageV1ExploreImagesExploreImageIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExploreImageV1ExploreImagesExploreImageIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExploreImageV1ExploreImagesExploreImageIdGetQueryKey(options)
});

/**
 * Replace Explore Image
 *
 * Replace an ExploreImage record completely (all fields required).
 */
export const replaceExploreImageV1ExploreImagesExploreImageIdPutMutation = (options?: Partial<Options<ReplaceExploreImageV1ExploreImagesExploreImageIdPutData>>): UseMutationOptions<ReplaceExploreImageV1ExploreImagesExploreImageIdPutResponse, ReplaceExploreImageV1ExploreImagesExploreImageIdPutError, Options<ReplaceExploreImageV1ExploreImagesExploreImageIdPutData>> => {
    const mutationOptions: UseMutationOptions<ReplaceExploreImageV1ExploreImagesExploreImageIdPutResponse, ReplaceExploreImageV1ExploreImagesExploreImageIdPutError, Options<ReplaceExploreImageV1ExploreImagesExploreImageIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await replaceExploreImageV1ExploreImagesExploreImageIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Explore Pdp
 *
 * Create a new ExplorePDP record for explore functionality.
 */
export const createExplorePdpV1ExplorePdpsPostMutation = (options?: Partial<Options<CreateExplorePdpV1ExplorePdpsPostData>>): UseMutationOptions<CreateExplorePdpV1ExplorePdpsPostResponse, CreateExplorePdpV1ExplorePdpsPostError, Options<CreateExplorePdpV1ExplorePdpsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateExplorePdpV1ExplorePdpsPostResponse, CreateExplorePdpV1ExplorePdpsPostError, Options<CreateExplorePdpV1ExplorePdpsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createExplorePdpV1ExplorePdpsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExplorePdpV1ExplorePdpsExplorePdpIdGetQueryKey = (options: Options<GetExplorePdpV1ExplorePdpsExplorePdpIdGetData>) => createQueryKey('getExplorePdpV1ExplorePdpsExplorePdpIdGet', options);

/**
 * Get Explore Pdp
 *
 * Get a specific ExplorePDP record by ID.
 */
export const getExplorePdpV1ExplorePdpsExplorePdpIdGetOptions = (options: Options<GetExplorePdpV1ExplorePdpsExplorePdpIdGetData>) => queryOptions<GetExplorePdpV1ExplorePdpsExplorePdpIdGetResponse, GetExplorePdpV1ExplorePdpsExplorePdpIdGetError, GetExplorePdpV1ExplorePdpsExplorePdpIdGetResponse, ReturnType<typeof getExplorePdpV1ExplorePdpsExplorePdpIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExplorePdpV1ExplorePdpsExplorePdpIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExplorePdpV1ExplorePdpsExplorePdpIdGetQueryKey(options)
});

/**
 * Update Explore Pdp
 *
 * Update an ExplorePDP record with partial data.
 */
export const updateExplorePdpV1ExplorePdpsExplorePdpIdPatchMutation = (options?: Partial<Options<UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchData>>): UseMutationOptions<UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchResponse, UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchError, Options<UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchResponse, UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchError, Options<UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateExplorePdpV1ExplorePdpsExplorePdpIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetQueryKey = (options: Options<GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetData>) => createQueryKey('getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGet', options);

/**
 * Get Classification Feedback
 *
 * Get the user's ClassificationFeedback record for a specific ExploreImage.
 */
export const getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetOptions = (options: Options<GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetData>) => queryOptions<GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetResponse, GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetError, GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetResponse, ReturnType<typeof getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetQueryKey(options)
});

/**
 * Create Classification Feedback
 *
 * Create a new ClassificationFeedback record for an ExploreImage.
 */
export const createClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostMutation = (options?: Partial<Options<CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostData>>): UseMutationOptions<CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostResponse, CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostError, Options<CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostData>> => {
    const mutationOptions: UseMutationOptions<CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostResponse, CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostError, Options<CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImageClassificationV1ExploreClassificationsClassificationIdGetQueryKey = (options: Options<GetImageClassificationV1ExploreClassificationsClassificationIdGetData>) => createQueryKey('getImageClassificationV1ExploreClassificationsClassificationIdGet', options);

/**
 * Get Image Classification
 *
 * Get a specific ImageClassification record by ID.
 */
export const getImageClassificationV1ExploreClassificationsClassificationIdGetOptions = (options: Options<GetImageClassificationV1ExploreClassificationsClassificationIdGetData>) => queryOptions<GetImageClassificationV1ExploreClassificationsClassificationIdGetResponse, GetImageClassificationV1ExploreClassificationsClassificationIdGetError, GetImageClassificationV1ExploreClassificationsClassificationIdGetResponse, ReturnType<typeof getImageClassificationV1ExploreClassificationsClassificationIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageClassificationV1ExploreClassificationsClassificationIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageClassificationV1ExploreClassificationsClassificationIdGetQueryKey(options)
});

export const listImageClassificationsV1ExploreClassificationsGetQueryKey = (options?: Options<ListImageClassificationsV1ExploreClassificationsGetData>) => createQueryKey('listImageClassificationsV1ExploreClassificationsGet', options);

/**
 * List Image Classifications
 *
 * Get a list of all ImageClassification records.
 */
export const listImageClassificationsV1ExploreClassificationsGetOptions = (options?: Options<ListImageClassificationsV1ExploreClassificationsGetData>) => queryOptions<ListImageClassificationsV1ExploreClassificationsGetResponse, DefaultError, ListImageClassificationsV1ExploreClassificationsGetResponse, ReturnType<typeof listImageClassificationsV1ExploreClassificationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listImageClassificationsV1ExploreClassificationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listImageClassificationsV1ExploreClassificationsGetQueryKey(options)
});

export const listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetQueryKey = (options: Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>) => createQueryKey('listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet', options);

/**
 * List Classification Images
 *
 * Dedups by (name, brand, score) so the same asset ingested under multiple queries shows once.
 */
export const listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetOptions = (options: Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>) => queryOptions<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponse, ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetError, ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponse, ReturnType<typeof listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetQueryKey(options)
});

export const listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetInfiniteQueryKey = (options: Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>): QueryKey<Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>> => createQueryKey('listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet', options, true);

/**
 * List Classification Images
 *
 * Dedups by (name, brand, score) so the same asset ingested under multiple queries shows once.
 */
export const listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetInfiniteOptions = (options: Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>) => infiniteQueryOptions<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponse, ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetError, InfiniteData<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponse>, QueryKey<Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>>, number | Pick<QueryKey<Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetInfiniteQueryKey(options)
});

/**
 * Create Query
 *
 * Create a new Query record for explore functionality.
 */
export const createQueryV1ExploreQueriesPostMutation = (options?: Partial<Options<CreateQueryV1ExploreQueriesPostData>>): UseMutationOptions<CreateQueryV1ExploreQueriesPostResponse, CreateQueryV1ExploreQueriesPostError, Options<CreateQueryV1ExploreQueriesPostData>> => {
    const mutationOptions: UseMutationOptions<CreateQueryV1ExploreQueriesPostResponse, CreateQueryV1ExploreQueriesPostError, Options<CreateQueryV1ExploreQueriesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createQueryV1ExploreQueriesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQueryV1ExploreQueriesQueryIdGetQueryKey = (options: Options<GetQueryV1ExploreQueriesQueryIdGetData>) => createQueryKey('getQueryV1ExploreQueriesQueryIdGet', options);

/**
 * Get Query
 *
 * Get a specific Query record by ID.
 */
export const getQueryV1ExploreQueriesQueryIdGetOptions = (options: Options<GetQueryV1ExploreQueriesQueryIdGetData>) => queryOptions<GetQueryV1ExploreQueriesQueryIdGetResponse, GetQueryV1ExploreQueriesQueryIdGetError, GetQueryV1ExploreQueriesQueryIdGetResponse, ReturnType<typeof getQueryV1ExploreQueriesQueryIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getQueryV1ExploreQueriesQueryIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getQueryV1ExploreQueriesQueryIdGetQueryKey(options)
});

/**
 * Update Query
 *
 * Update a Query record with partial data.
 */
export const updateQueryV1ExploreQueriesQueryIdPatchMutation = (options?: Partial<Options<UpdateQueryV1ExploreQueriesQueryIdPatchData>>): UseMutationOptions<UpdateQueryV1ExploreQueriesQueryIdPatchResponse, UpdateQueryV1ExploreQueriesQueryIdPatchError, Options<UpdateQueryV1ExploreQueriesQueryIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateQueryV1ExploreQueriesQueryIdPatchResponse, UpdateQueryV1ExploreQueriesQueryIdPatchError, Options<UpdateQueryV1ExploreQueriesQueryIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateQueryV1ExploreQueriesQueryIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFeatureFlagsV1FeatureFlagsGetQueryKey = (options?: Options<ListFeatureFlagsV1FeatureFlagsGetData>) => createQueryKey('listFeatureFlagsV1FeatureFlagsGet', options);

/**
 * List Feature Flags
 *
 * Evaluate all BE feature flags for the current authenticated user.
 */
export const listFeatureFlagsV1FeatureFlagsGetOptions = (options?: Options<ListFeatureFlagsV1FeatureFlagsGetData>) => queryOptions<ListFeatureFlagsV1FeatureFlagsGetResponse, DefaultError, ListFeatureFlagsV1FeatureFlagsGetResponse, ReturnType<typeof listFeatureFlagsV1FeatureFlagsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFeatureFlagsV1FeatureFlagsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFeatureFlagsV1FeatureFlagsGetQueryKey(options)
});

export const getFeatureFlagV1FeatureFlagsFlagGetQueryKey = (options: Options<GetFeatureFlagV1FeatureFlagsFlagGetData>) => createQueryKey('getFeatureFlagV1FeatureFlagsFlagGet', options);

/**
 * Get Feature Flag
 *
 * Evaluate a single feature flag for the current authenticated user.
 */
export const getFeatureFlagV1FeatureFlagsFlagGetOptions = (options: Options<GetFeatureFlagV1FeatureFlagsFlagGetData>) => queryOptions<GetFeatureFlagV1FeatureFlagsFlagGetResponse, GetFeatureFlagV1FeatureFlagsFlagGetError, GetFeatureFlagV1FeatureFlagsFlagGetResponse, ReturnType<typeof getFeatureFlagV1FeatureFlagsFlagGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFeatureFlagV1FeatureFlagsFlagGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFeatureFlagV1FeatureFlagsFlagGetQueryKey(options)
});

export const searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetQueryKey = (options: Options<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetData>) => createQueryKey('searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGet', options);

/**
 * Search Ideas
 */
export const searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetOptions = (options: Options<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetData>) => queryOptions<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetResponse, SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetError, SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetResponse, ReturnType<typeof searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetQueryKey(options)
});

export const searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetInfiniteQueryKey = (options: Options<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetData>): QueryKey<Options<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetData>> => createQueryKey('searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGet', options, true);

/**
 * Search Ideas
 */
export const searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetInfiniteOptions = (options: Options<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetData>) => infiniteQueryOptions<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetResponse, SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetError, InfiniteData<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetResponse>, QueryKey<Options<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetData>>, number | Pick<QueryKey<Options<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchIdeasV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasGetInfiniteQueryKey(options)
});

/**
 * Create Idea
 */
export const createIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostMutation = (options?: Partial<Options<CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostData>>): UseMutationOptions<CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostResponse, CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostError, Options<CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostData>> => {
    const mutationOptions: UseMutationOptions<CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostResponse, CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostError, Options<CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetQueryKey = (options: Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>) => createQueryKey('searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet', options);

/**
 * Search Ideas
 */
export const searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetOptions = (options: Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>) => queryOptions<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponse, SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetError, SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponse, ReturnType<typeof searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetQueryKey(options)
});

export const searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetInfiniteQueryKey = (options: Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>): QueryKey<Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>> => createQueryKey('searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet', options, true);

/**
 * Search Ideas
 */
export const searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetInfiniteOptions = (options: Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>) => infiniteQueryOptions<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponse, SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetError, InfiniteData<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponse>, QueryKey<Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>>, number | Pick<QueryKey<Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetInfiniteQueryKey(options)
});

/**
 * Create Idea
 */
export const createIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostMutation = (options?: Partial<Options<CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData>>): UseMutationOptions<CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostResponse, CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostError, Options<CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData>> => {
    const mutationOptions: UseMutationOptions<CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostResponse, CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostError, Options<CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetQueryKey = (options: Options<GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetData>) => createQueryKey('getIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGet', options);

/**
 * Get Idea
 */
export const getIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetOptions = (options: Options<GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetData>) => queryOptions<GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetResponse, GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetError, GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetResponse, ReturnType<typeof getIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetQueryKey(options)
});

export const getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetQueryKey = (options: Options<GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetData>) => createQueryKey('getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGet', options);

/**
 * Get Idea
 */
export const getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetOptions = (options: Options<GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetData>) => queryOptions<GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetResponse, GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetError, GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetResponse, ReturnType<typeof getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetQueryKey(options)
});

export const downloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetQueryKey = (options: Options<DownloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetData>) => createQueryKey('downloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGet', options);

/**
 * Download Image Bundle
 */
export const downloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetOptions = (options: Options<DownloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetData>) => queryOptions<DownloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetResponse, DownloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetError, DownloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetResponse, ReturnType<typeof downloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadImageBundleV1WorkspacesWorkspaceIdAssetsImagesImageIdDownloadGetQueryKey(options)
});

export const downloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetQueryKey = (options: Options<DownloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetData>) => createQueryKey('downloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGet', options);

/**
 * Download Image Bundle
 */
export const downloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetOptions = (options: Options<DownloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetData>) => queryOptions<DownloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetResponse, DownloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetError, DownloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetResponse, ReturnType<typeof downloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadImageBundleV1PortfoliosPortfolioIdAssetsImagesImageIdDownloadGetQueryKey(options)
});

export const searchImagesV1WorkspacesWorkspaceIdAssetsImagesGetQueryKey = (options: Options<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetData>) => createQueryKey('searchImagesV1WorkspacesWorkspaceIdAssetsImagesGet', options);

/**
 * Search Images
 *
 * Retrieves images for a portfolio with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID(s) to find children (multi-select)
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - product_category_id: Filter by product category ID(s)
 * - image_type: Filter by image type (hero or carousel)
 * - include_rejected: If true, include REJECTED images (default false)
 * - favorite: If true, only favorited images; if false, only non-favorited. Omit for both.
 */
export const searchImagesV1WorkspacesWorkspaceIdAssetsImagesGetOptions = (options: Options<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetData>) => queryOptions<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetResponse, SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetError, SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetResponse, ReturnType<typeof searchImagesV1WorkspacesWorkspaceIdAssetsImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchImagesV1WorkspacesWorkspaceIdAssetsImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchImagesV1WorkspacesWorkspaceIdAssetsImagesGetQueryKey(options)
});

export const searchImagesV1WorkspacesWorkspaceIdAssetsImagesGetInfiniteQueryKey = (options: Options<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetData>): QueryKey<Options<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetData>> => createQueryKey('searchImagesV1WorkspacesWorkspaceIdAssetsImagesGet', options, true);

/**
 * Search Images
 *
 * Retrieves images for a portfolio with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID(s) to find children (multi-select)
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - product_category_id: Filter by product category ID(s)
 * - image_type: Filter by image type (hero or carousel)
 * - include_rejected: If true, include REJECTED images (default false)
 * - favorite: If true, only favorited images; if false, only non-favorited. Omit for both.
 */
export const searchImagesV1WorkspacesWorkspaceIdAssetsImagesGetInfiniteOptions = (options: Options<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetData>) => infiniteQueryOptions<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetResponse, SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetError, InfiniteData<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetResponse>, QueryKey<Options<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetData>>, number | Pick<QueryKey<Options<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchImagesV1WorkspacesWorkspaceIdAssetsImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchImagesV1WorkspacesWorkspaceIdAssetsImagesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchImagesV1WorkspacesWorkspaceIdAssetsImagesGetInfiniteQueryKey(options)
});

/**
 * Upload Image
 *
 * Uploads image metadata and returns the Image model
 */
export const uploadImageV1WorkspacesWorkspaceIdAssetsImagesPostMutation = (options?: Partial<Options<UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostData>>): UseMutationOptions<UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostResponse, UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostError, Options<UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostData>> => {
    const mutationOptions: UseMutationOptions<UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostResponse, UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostError, Options<UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadImageV1WorkspacesWorkspaceIdAssetsImagesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchImagesV1PortfoliosPortfolioIdAssetsImagesGetQueryKey = (options: Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>) => createQueryKey('searchImagesV1PortfoliosPortfolioIdAssetsImagesGet', options);

/**
 * Search Images
 *
 * Retrieves images for a portfolio with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID(s) to find children (multi-select)
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - product_category_id: Filter by product category ID(s)
 * - image_type: Filter by image type (hero or carousel)
 * - include_rejected: If true, include REJECTED images (default false)
 * - favorite: If true, only favorited images; if false, only non-favorited. Omit for both.
 */
export const searchImagesV1PortfoliosPortfolioIdAssetsImagesGetOptions = (options: Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>) => queryOptions<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponse, SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetError, SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponse, ReturnType<typeof searchImagesV1PortfoliosPortfolioIdAssetsImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchImagesV1PortfoliosPortfolioIdAssetsImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchImagesV1PortfoliosPortfolioIdAssetsImagesGetQueryKey(options)
});

export const searchImagesV1PortfoliosPortfolioIdAssetsImagesGetInfiniteQueryKey = (options: Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>): QueryKey<Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>> => createQueryKey('searchImagesV1PortfoliosPortfolioIdAssetsImagesGet', options, true);

/**
 * Search Images
 *
 * Retrieves images for a portfolio with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID(s) to find children (multi-select)
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - product_category_id: Filter by product category ID(s)
 * - image_type: Filter by image type (hero or carousel)
 * - include_rejected: If true, include REJECTED images (default false)
 * - favorite: If true, only favorited images; if false, only non-favorited. Omit for both.
 */
export const searchImagesV1PortfoliosPortfolioIdAssetsImagesGetInfiniteOptions = (options: Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>) => infiniteQueryOptions<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponse, SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetError, InfiniteData<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponse>, QueryKey<Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>>, number | Pick<QueryKey<Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchImagesV1PortfoliosPortfolioIdAssetsImagesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchImagesV1PortfoliosPortfolioIdAssetsImagesGetInfiniteQueryKey(options)
});

/**
 * Upload Image
 *
 * Uploads image metadata and returns the Image model
 */
export const uploadImageV1PortfoliosPortfolioIdAssetsImagesPostMutation = (options?: Partial<Options<UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData>>): UseMutationOptions<UploadImageV1PortfoliosPortfolioIdAssetsImagesPostResponse, UploadImageV1PortfoliosPortfolioIdAssetsImagesPostError, Options<UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData>> => {
    const mutationOptions: UseMutationOptions<UploadImageV1PortfoliosPortfolioIdAssetsImagesPostResponse, UploadImageV1PortfoliosPortfolioIdAssetsImagesPostError, Options<UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadImageV1PortfoliosPortfolioIdAssetsImagesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Image
 *
 * Delete a portfolio image.
 */
export const deleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteMutation = (options?: Partial<Options<DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteData>>): UseMutationOptions<DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteResponse, DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteError, Options<DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteResponse, DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteError, Options<DeleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetQueryKey = (options: Options<GetImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetData>) => createQueryKey('getImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGet', options);

/**
 * Get Image
 *
 * returns an Image by ID
 */
export const getImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetOptions = (options: Options<GetImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetData>) => queryOptions<GetImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetResponse, GetImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetError, GetImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetResponse, ReturnType<typeof getImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageV1WorkspacesWorkspaceIdAssetsImagesImageIdGetQueryKey(options)
});

/**
 * Delete Image
 *
 * Delete a portfolio image.
 */
export const deleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteMutation = (options?: Partial<Options<DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData>>): UseMutationOptions<DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteResponse, DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteError, Options<DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteResponse, DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteError, Options<DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetQueryKey = (options: Options<GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetData>) => createQueryKey('getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGet', options);

/**
 * Get Image
 *
 * returns an Image by ID
 */
export const getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetOptions = (options: Options<GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetData>) => queryOptions<GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetResponse, GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetError, GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetResponse, ReturnType<typeof getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetQueryKey(options)
});

export const getImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetQueryKey = (options: Options<GetImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetData>) => createQueryKey('getImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGet', options);

/**
 * Get Image Scoring Context
 *
 * Scoring context for the Lambda image scorer, from the image's PDP membership.
 */
export const getImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetOptions = (options: Options<GetImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetData>) => queryOptions<GetImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetResponse, GetImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetError, GetImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetResponse, ReturnType<typeof getImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageScoringContextV1WorkspacesWorkspaceIdAssetsImagesImageIdScoringContextGetQueryKey(options)
});

export const getImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetQueryKey = (options: Options<GetImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetData>) => createQueryKey('getImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGet', options);

/**
 * Get Image Scoring Context
 *
 * Scoring context for the Lambda image scorer, from the image's PDP membership.
 */
export const getImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetOptions = (options: Options<GetImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetData>) => queryOptions<GetImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetResponse, GetImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetError, GetImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetResponse, ReturnType<typeof getImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageScoringContextV1PortfoliosPortfolioIdAssetsImagesImageIdScoringContextGetQueryKey(options)
});

/**
 * Update an asset's classification
 *
 * Update an asset's classification. Only heroes are not editable.
 */
export const updateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchMutation = (options?: Partial<Options<UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchData>>): UseMutationOptions<UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchResponse, UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchError, Options<UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchResponse, UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchError, Options<UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an asset's classification
 *
 * Update an asset's classification. Only heroes are not editable.
 */
export const updateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchMutation = (options?: Partial<Options<UpdateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchData>>): UseMutationOptions<UpdateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchResponse, UpdateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchError, Options<UpdateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchResponse, UpdateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchError, Options<UpdateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set a per-image title for PDP-accurate collection hero scoring
 */
export const updateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchMutation = (options?: Partial<Options<UpdateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchData>>): UseMutationOptions<UpdateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchResponse, UpdateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchError, Options<UpdateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchResponse, UpdateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchError, Options<UpdateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateImageProductTitleV1WorkspacesWorkspaceIdAssetsImagesImageIdProductTitlePatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set a per-image title for PDP-accurate collection hero scoring
 */
export const updateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchMutation = (options?: Partial<Options<UpdateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchData>>): UseMutationOptions<UpdateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchResponse, UpdateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchError, Options<UpdateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchResponse, UpdateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchError, Options<UpdateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateImageProductTitleV1PortfoliosPortfolioIdAssetsImagesImageIdProductTitlePatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove an asset's favorite mark for its workspace
 *
 * Idempotent: unfavoriting an unfavorited asset is not a toggle.
 */
export const unfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteMutation = (options?: Partial<Options<UnfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteData>>): UseMutationOptions<UnfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteResponse, UnfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteError, Options<UnfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteData>> => {
    const mutationOptions: UseMutationOptions<UnfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteResponse, UnfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteError, Options<UnfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unfavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoriteDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark an asset as a favorite for its workspace
 *
 * Idempotent: favoriting an already-favorited asset is not a toggle.
 */
export const favoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutMutation = (options?: Partial<Options<FavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutData>>): UseMutationOptions<FavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutResponse, FavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutError, Options<FavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutData>> => {
    const mutationOptions: UseMutationOptions<FavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutResponse, FavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutError, Options<FavoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await favoriteImageV1WorkspacesWorkspaceIdAssetsImagesImageIdFavoritePut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove an asset's favorite mark for its workspace
 *
 * Idempotent: unfavoriting an unfavorited asset is not a toggle.
 */
export const unfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteMutation = (options?: Partial<Options<UnfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteData>>): UseMutationOptions<UnfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteResponse, UnfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteError, Options<UnfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteData>> => {
    const mutationOptions: UseMutationOptions<UnfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteResponse, UnfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteError, Options<UnfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unfavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoriteDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark an asset as a favorite for its workspace
 *
 * Idempotent: favoriting an already-favorited asset is not a toggle.
 */
export const favoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutMutation = (options?: Partial<Options<FavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutData>>): UseMutationOptions<FavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutResponse, FavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutError, Options<FavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutData>> => {
    const mutationOptions: UseMutationOptions<FavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutResponse, FavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutError, Options<FavoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await favoriteImageV1PortfoliosPortfolioIdAssetsImagesImageIdFavoritePut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset an asset's classification to its ML-detected original
 *
 * Lets a user undo a manual class override and return the asset to its original class.
 */
export const resetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostMutation = (options?: Partial<Options<ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostData>>): UseMutationOptions<ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostResponse, ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostError, Options<ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostData>> => {
    const mutationOptions: UseMutationOptions<ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostResponse, ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostError, Options<ResetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationResetPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset an asset's classification to its ML-detected original
 *
 * Lets a user undo a manual class override and return the asset to its original class.
 */
export const resetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostMutation = (options?: Partial<Options<ResetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostData>>): UseMutationOptions<ResetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostResponse, ResetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostError, Options<ResetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostData>> => {
    const mutationOptions: UseMutationOptions<ResetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostResponse, ResetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostError, Options<ResetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetImageClassificationV1PortfoliosPortfolioIdAssetsImagesImageIdClassificationResetPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDispatchContextV1InternalImagesImageIdDispatchContextGetQueryKey = (options: Options<GetDispatchContextV1InternalImagesImageIdDispatchContextGetData>) => createQueryKey('getDispatchContextV1InternalImagesImageIdDispatchContextGet', options);

/**
 * Get Dispatch Context
 */
export const getDispatchContextV1InternalImagesImageIdDispatchContextGetOptions = (options: Options<GetDispatchContextV1InternalImagesImageIdDispatchContextGetData>) => queryOptions<GetDispatchContextV1InternalImagesImageIdDispatchContextGetResponse, GetDispatchContextV1InternalImagesImageIdDispatchContextGetError, GetDispatchContextV1InternalImagesImageIdDispatchContextGetResponse, ReturnType<typeof getDispatchContextV1InternalImagesImageIdDispatchContextGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDispatchContextV1InternalImagesImageIdDispatchContextGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDispatchContextV1InternalImagesImageIdDispatchContextGetQueryKey(options)
});

/**
 * Create Image Score
 *
 * Returns a minimal dict, not an ImageView, to skip S3 signed-URL work Lambda callers do not use.
 */
export const createImageScoreV1AssetsImagesImageIdRawScorePostMutation = (options?: Partial<Options<CreateImageScoreV1AssetsImagesImageIdRawScorePostData>>): UseMutationOptions<CreateImageScoreV1AssetsImagesImageIdRawScorePostResponse, CreateImageScoreV1AssetsImagesImageIdRawScorePostError, Options<CreateImageScoreV1AssetsImagesImageIdRawScorePostData>> => {
    const mutationOptions: UseMutationOptions<CreateImageScoreV1AssetsImagesImageIdRawScorePostResponse, CreateImageScoreV1AssetsImagesImageIdRawScorePostError, Options<CreateImageScoreV1AssetsImagesImageIdRawScorePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createImageScoreV1AssetsImagesImageIdRawScorePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Image Classification
 *
 * Returns a minimal dict, not an ImageView, to skip S3 signed-URL work Lambda callers do not use.
 */
export const createImageClassificationV1AssetsImagesImageIdClassificationPostMutation = (options?: Partial<Options<CreateImageClassificationV1AssetsImagesImageIdClassificationPostData>>): UseMutationOptions<CreateImageClassificationV1AssetsImagesImageIdClassificationPostResponse, CreateImageClassificationV1AssetsImagesImageIdClassificationPostError, Options<CreateImageClassificationV1AssetsImagesImageIdClassificationPostData>> => {
    const mutationOptions: UseMutationOptions<CreateImageClassificationV1AssetsImagesImageIdClassificationPostResponse, CreateImageClassificationV1AssetsImagesImageIdClassificationPostError, Options<CreateImageClassificationV1AssetsImagesImageIdClassificationPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createImageClassificationV1AssetsImagesImageIdClassificationPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Batch Update Image Classifications
 *
 * Returns a minimal dict, not an ImageView, to skip S3 signed-URL work Lambda callers do not use.
 */
export const batchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostMutation = (options?: Partial<Options<BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostData>>): UseMutationOptions<BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostResponse, BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostError, Options<BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostData>> => {
    const mutationOptions: UseMutationOptions<BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostResponse, BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostError, Options<BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Exclusion Prediction
 *
 * Returns a minimal dict, not an ImageView, to skip S3 signed-URL work Lambda callers do not use.
 */
export const createExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostMutation = (options?: Partial<Options<CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostData>>): UseMutationOptions<CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostResponse, CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostError, Options<CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostData>> => {
    const mutationOptions: UseMutationOptions<CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostResponse, CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostError, Options<CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Mobile Readiness Score
 *
 * Returns a minimal dict, not an ImageView; the six columns written here are
 * exposed read-only through ImageView and PdpView.
 */
export const createMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostMutation = (options?: Partial<Options<CreateMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostData>>): UseMutationOptions<CreateMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostResponse, CreateMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostError, Options<CreateMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostData>> => {
    const mutationOptions: UseMutationOptions<CreateMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostResponse, CreateMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostError, Options<CreateMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMobileReadinessScoreV1AssetsImagesImageIdMobileReadinessScorePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Idea For Image
 *
 * Internal endpoint for the images-first GS1 eager idea.
 *
 * Creates a COMPLETED Idea with the supplied markdown ``output`` and does not
 * enqueue SQS, since the idea text is already materialized upstream.
 */
export const createIdeaForImageV1InternalImagesImageIdIdeasPostMutation = (options?: Partial<Options<CreateIdeaForImageV1InternalImagesImageIdIdeasPostData>>): UseMutationOptions<CreateIdeaForImageV1InternalImagesImageIdIdeasPostResponse, CreateIdeaForImageV1InternalImagesImageIdIdeasPostError, Options<CreateIdeaForImageV1InternalImagesImageIdIdeasPostData>> => {
    const mutationOptions: UseMutationOptions<CreateIdeaForImageV1InternalImagesImageIdIdeasPostResponse, CreateIdeaForImageV1InternalImagesImageIdIdeasPostError, Options<CreateIdeaForImageV1InternalImagesImageIdIdeasPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createIdeaForImageV1InternalImagesImageIdIdeasPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImagesScoringDataV1InternalImagesScoringDataGetQueryKey = (options: Options<GetImagesScoringDataV1InternalImagesScoringDataGetData>) => createQueryKey('getImagesScoringDataV1InternalImagesScoringDataGet', options);

/**
 * Get Images Scoring Data
 */
export const getImagesScoringDataV1InternalImagesScoringDataGetOptions = (options: Options<GetImagesScoringDataV1InternalImagesScoringDataGetData>) => queryOptions<GetImagesScoringDataV1InternalImagesScoringDataGetResponse, GetImagesScoringDataV1InternalImagesScoringDataGetError, GetImagesScoringDataV1InternalImagesScoringDataGetResponse, ReturnType<typeof getImagesScoringDataV1InternalImagesScoringDataGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImagesScoringDataV1InternalImagesScoringDataGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImagesScoringDataV1InternalImagesScoringDataGetQueryKey(options)
});

/**
 * Create Scoring Results
 *
 * Returns a minimal dict, not an ImageView, to skip S3 signed-URL work Lambda callers do not use.
 */
export const createScoringResultsV1InternalImagesImageIdScoringResultsPostMutation = (options?: Partial<Options<CreateScoringResultsV1InternalImagesImageIdScoringResultsPostData>>): UseMutationOptions<CreateScoringResultsV1InternalImagesImageIdScoringResultsPostResponse, CreateScoringResultsV1InternalImagesImageIdScoringResultsPostError, Options<CreateScoringResultsV1InternalImagesImageIdScoringResultsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateScoringResultsV1InternalImagesImageIdScoringResultsPostResponse, CreateScoringResultsV1InternalImagesImageIdScoringResultsPostError, Options<CreateScoringResultsV1InternalImagesImageIdScoringResultsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createScoringResultsV1InternalImagesImageIdScoringResultsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetQueryKey = (options: Options<GetImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetData>) => createQueryKey('getImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGet', options);

/**
 * Get Image Count
 */
export const getImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetOptions = (options: Options<GetImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetData>) => queryOptions<GetImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetResponse, GetImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetError, GetImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetResponse, ReturnType<typeof getImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageCountV1WorkspacesWorkspaceIdPdpsPdpIdImageCountGetQueryKey(options)
});

export const getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetQueryKey = (options: Options<GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetData>) => createQueryKey('getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGet', options);

/**
 * Get Image Count
 */
export const getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetOptions = (options: Options<GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetData>) => queryOptions<GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetResponse, GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetError, GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetResponse, ReturnType<typeof getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetQueryKey(options)
});

/**
 * Generate Prompts For Image
 *
 * Create ImageGenPrompts records for an image and trigger parallel processing.
 *
 * The request body is optional; an omitted body defaults ``generation_mode``
 * to ``"reuse"`` and ``validate_only`` to ``False``, exactly today's
 * behavior. ``generation_mode="fresh"`` forces a brand-new step-1 compute
 * even when a completed spark output exists (benchmarking).
 * ``generation_mode="generate_more"`` requires the batch to follow the
 * generate-more path; when the preconditions aren't met this returns 422.
 * ``validate_only=True`` (only meaningful with ``generate_more``) runs those
 * preconditions and returns without creating any records or sending SQS.
 * ``prompt`` is a free-text direction for the next round: only
 * ``generate_more`` reads it, and it is vetted in the worker before it reaches
 * a generation prompt, so ``validate_only`` checks its length but not its
 * content.
 */
export const generatePromptsForImageV1ImagesImageIdGeneratePromptsPostMutation = (options?: Partial<Options<GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData>>): UseMutationOptions<GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostResponse, GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostError, Options<GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData>> => {
    const mutationOptions: UseMutationOptions<GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostResponse, GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostError, Options<GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generatePromptsForImageV1ImagesImageIdGeneratePromptsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetQueryKey = (options: Options<GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetData>) => createQueryKey('getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGet', options);

/**
 * Get Batch Status
 *
 * Get the status of a batch of ImageGenPrompts records for a specific image.
 *
 * Runs ``SparkCullService.settle_if_ready`` so the FE's existing poll loop drives
 * the cull on its next tick if both event triggers somehow missed. The cull's
 * progress per image is communicated via ``ImageView.visibility``, not here —
 * the FE renders VISIBLE images as they settle, with PENDING_REVIEW siblings
 * shown as skeletons until decided.
 */
export const getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetOptions = (options: Options<GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetData>) => queryOptions<GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetResponse, GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetError, GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetResponse, ReturnType<typeof getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetQueryKey(options)
});

/**
 * Delete Image Gen Prompt
 *
 * Delete an ImageGenPrompts record.
 */
export const deleteImageGenPromptV1ImageGenPromptsPromptIdDeleteMutation = (options?: Partial<Options<DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteData>>): UseMutationOptions<DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteResponse, DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteError, Options<DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteResponse, DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteError, Options<DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteImageGenPromptV1ImageGenPromptsPromptIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImageGenPromptV1ImageGenPromptsPromptIdGetQueryKey = (options: Options<GetImageGenPromptV1ImageGenPromptsPromptIdGetData>) => createQueryKey('getImageGenPromptV1ImageGenPromptsPromptIdGet', options);

/**
 * Get Image Gen Prompt
 *
 * Get a specific ImageGenPrompts record by ID.
 */
export const getImageGenPromptV1ImageGenPromptsPromptIdGetOptions = (options: Options<GetImageGenPromptV1ImageGenPromptsPromptIdGetData>) => queryOptions<GetImageGenPromptV1ImageGenPromptsPromptIdGetResponse, GetImageGenPromptV1ImageGenPromptsPromptIdGetError, GetImageGenPromptV1ImageGenPromptsPromptIdGetResponse, ReturnType<typeof getImageGenPromptV1ImageGenPromptsPromptIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageGenPromptV1ImageGenPromptsPromptIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageGenPromptV1ImageGenPromptsPromptIdGetQueryKey(options)
});

/**
 * Update Image Gen Prompt
 *
 * Update an ImageGenPrompts record status and/or output.
 *
 * When the new status is COMPLETED or FAILED, fire
 * ``SparkCullService.on_prompt_terminal`` so a batch where the last-arriving
 * event is a prompt failure (no image scored) still settles.
 */
export const updateImageGenPromptV1ImageGenPromptsPromptIdPatchMutation = (options?: Partial<Options<UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchData>>): UseMutationOptions<unknown, UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchError, Options<UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchError, Options<UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateImageGenPromptV1ImageGenPromptsPromptIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImageByIdV1ImagesImageIdGetQueryKey = (options: Options<GetImageByIdV1ImagesImageIdGetData>) => createQueryKey('getImageByIdV1ImagesImageIdGet', options);

/**
 * Get Image By Id
 *
 * Get a specific Image record by ID (for Lambda function use).
 */
export const getImageByIdV1ImagesImageIdGetOptions = (options: Options<GetImageByIdV1ImagesImageIdGetData>) => queryOptions<GetImageByIdV1ImagesImageIdGetResponse, GetImageByIdV1ImagesImageIdGetError, GetImageByIdV1ImagesImageIdGetResponse, ReturnType<typeof getImageByIdV1ImagesImageIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageByIdV1ImagesImageIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageByIdV1ImagesImageIdGetQueryKey(options)
});

export const getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetQueryKey = (options: Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>) => createQueryKey('getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet', options);

/**
 * Get Image Gen Prompts For Image
 *
 * Get all ImageGenPrompts records for a specific image.
 */
export const getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetOptions = (options: Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>) => queryOptions<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponse, GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetError, GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponse, ReturnType<typeof getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetQueryKey(options)
});

export const getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetInfiniteQueryKey = (options: Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>): QueryKey<Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>> => createQueryKey('getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet', options, true);

/**
 * Get Image Gen Prompts For Image
 *
 * Get all ImageGenPrompts records for a specific image.
 */
export const getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetInfiniteOptions = (options: Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>) => infiniteQueryOptions<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponse, GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetError, InfiniteData<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponse>, QueryKey<Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>>, number | Pick<QueryKey<Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetInfiniteQueryKey(options)
});

export const getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetQueryKey = (options: Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>) => createQueryKey('getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet', options);

/**
 * Get Image Gen Prompts For Category
 *
 * Get all ImageGenPrompts records for a specific product category, optionally filtered by status.
 */
export const getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetOptions = (options: Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>) => queryOptions<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponse, GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetError, GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponse, ReturnType<typeof getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetQueryKey(options)
});

export const getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetInfiniteQueryKey = (options: Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>): QueryKey<Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>> => createQueryKey('getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet', options, true);

/**
 * Get Image Gen Prompts For Category
 *
 * Get all ImageGenPrompts records for a specific product category, optionally filtered by status.
 */
export const getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetInfiniteOptions = (options: Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>) => infiniteQueryOptions<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponse, GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetError, InfiniteData<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponse>, QueryKey<Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>>, number | Pick<QueryKey<Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetInfiniteQueryKey(options)
});

export const getImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetQueryKey = (options: Options<GetImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetData>) => createQueryKey('getImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGet', options);

/**
 * Get Image Order
 */
export const getImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetOptions = (options: Options<GetImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetData>) => queryOptions<GetImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetResponse, GetImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetError, GetImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetResponse, ReturnType<typeof getImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageOrderV1WorkspacesWorkspaceIdPdpsPdpIdImageOrderGetQueryKey(options)
});

export const getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetQueryKey = (options: Options<GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetData>) => createQueryKey('getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGet', options);

/**
 * Get Image Order
 */
export const getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetOptions = (options: Options<GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetData>) => queryOptions<GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetResponse, GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetError, GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetResponse, ReturnType<typeof getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetQueryKey(options)
});

export const getImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetQueryKey = (options: Options<GetImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetData>) => createQueryKey('getImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGet', options);

/**
 * Get Image Mix
 */
export const getImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetOptions = (options: Options<GetImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetData>) => queryOptions<GetImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetResponse, GetImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetError, GetImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetResponse, ReturnType<typeof getImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageMixV1WorkspacesWorkspaceIdPdpsPdpIdImageMixGetQueryKey(options)
});

export const getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetQueryKey = (options: Options<GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetData>) => createQueryKey('getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGet', options);

/**
 * Get Image Mix
 */
export const getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetOptions = (options: Options<GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetData>) => queryOptions<GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetResponse, GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetError, GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetResponse, ReturnType<typeof getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetQueryKey(options)
});

export const getImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetQueryKey = (options: Options<GetImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetData>) => createQueryKey('getImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGet', options);

/**
 * Get Image Scores
 */
export const getImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetOptions = (options: Options<GetImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetData>) => queryOptions<GetImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetResponse, GetImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetError, GetImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetResponse, ReturnType<typeof getImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageScoresV1WorkspacesWorkspaceIdPdpsPdpIdImageScoresGetQueryKey(options)
});

export const getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetQueryKey = (options: Options<GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetData>) => createQueryKey('getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGet', options);

/**
 * Get Image Scores
 */
export const getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetOptions = (options: Options<GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetData>) => queryOptions<GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetResponse, GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetError, GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetResponse, ReturnType<typeof getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetQueryKey(options)
});

export const findIntegrationV1IntegrationsGetQueryKey = (options: Options<FindIntegrationV1IntegrationsGetData>) => createQueryKey('findIntegrationV1IntegrationsGet', options);

/**
 * Find Integration
 */
export const findIntegrationV1IntegrationsGetOptions = (options: Options<FindIntegrationV1IntegrationsGetData>) => queryOptions<FindIntegrationV1IntegrationsGetResponse, FindIntegrationV1IntegrationsGetError, FindIntegrationV1IntegrationsGetResponse, ReturnType<typeof findIntegrationV1IntegrationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findIntegrationV1IntegrationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findIntegrationV1IntegrationsGetQueryKey(options)
});

export const getIntegrationV1IntegrationsIntegrationIdGetQueryKey = (options: Options<GetIntegrationV1IntegrationsIntegrationIdGetData>) => createQueryKey('getIntegrationV1IntegrationsIntegrationIdGet', options);

/**
 * Get Integration
 */
export const getIntegrationV1IntegrationsIntegrationIdGetOptions = (options: Options<GetIntegrationV1IntegrationsIntegrationIdGetData>) => queryOptions<GetIntegrationV1IntegrationsIntegrationIdGetResponse, GetIntegrationV1IntegrationsIntegrationIdGetError, GetIntegrationV1IntegrationsIntegrationIdGetResponse, ReturnType<typeof getIntegrationV1IntegrationsIntegrationIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIntegrationV1IntegrationsIntegrationIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIntegrationV1IntegrationsIntegrationIdGetQueryKey(options)
});

export const getMeV1MeGetQueryKey = (options?: Options<GetMeV1MeGetData>) => createQueryKey('getMeV1MeGet', options);

/**
 * Get Me
 */
export const getMeV1MeGetOptions = (options?: Options<GetMeV1MeGetData>) => queryOptions<GetMeV1MeGetResponse, DefaultError, GetMeV1MeGetResponse, ReturnType<typeof getMeV1MeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMeV1MeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeV1MeGetQueryKey(options)
});

/**
 * Create Organization
 */
export const createOrganizationV1OrganizationsPostMutation = (options?: Partial<Options<CreateOrganizationV1OrganizationsPostData>>): UseMutationOptions<CreateOrganizationV1OrganizationsPostResponse, CreateOrganizationV1OrganizationsPostError, Options<CreateOrganizationV1OrganizationsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateOrganizationV1OrganizationsPostResponse, CreateOrganizationV1OrganizationsPostError, Options<CreateOrganizationV1OrganizationsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrganizationV1OrganizationsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Organization Icp Product Category
 */
export const deleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteMutation = (options?: Partial<Options<DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData>>): UseMutationOptions<DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteResponse, DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteError, Options<DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteResponse, DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteError, Options<DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Organization Icp Product Category
 *
 * Creates an ICP product category linked to an organization, returns the ICP product category
 */
export const createOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostMutation = (options?: Partial<Options<CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData>>): UseMutationOptions<CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostResponse, CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostError, Options<CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData>> => {
    const mutationOptions: UseMutationOptions<CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostResponse, CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostError, Options<CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Retailer Region From Organization
 *
 * Unlink a retailer region from an organization.
 */
export const removeRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteMutation = (options?: Partial<Options<RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData>>): UseMutationOptions<RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteResponse, RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteError, Options<RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteResponse, RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteError, Options<RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Retailer Region To Organization
 *
 * Link a retailer region to an organization.
 */
export const addRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostMutation = (options?: Partial<Options<AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData>>): UseMutationOptions<AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostResponse, AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostError, Options<AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData>> => {
    const mutationOptions: UseMutationOptions<AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostResponse, AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostError, Options<AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrganizationV1OrganizationsOrgIdGetQueryKey = (options: Options<GetOrganizationV1OrganizationsOrgIdGetData>) => createQueryKey('getOrganizationV1OrganizationsOrgIdGet', options);

/**
 * Get Organization
 */
export const getOrganizationV1OrganizationsOrgIdGetOptions = (options: Options<GetOrganizationV1OrganizationsOrgIdGetData>) => queryOptions<GetOrganizationV1OrganizationsOrgIdGetResponse, GetOrganizationV1OrganizationsOrgIdGetError, GetOrganizationV1OrganizationsOrgIdGetResponse, ReturnType<typeof getOrganizationV1OrganizationsOrgIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationV1OrganizationsOrgIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationV1OrganizationsOrgIdGetQueryKey(options)
});

/**
 * Update Organization
 */
export const updateOrganizationV1OrganizationsOrgIdPutMutation = (options?: Partial<Options<UpdateOrganizationV1OrganizationsOrgIdPutData>>): UseMutationOptions<UpdateOrganizationV1OrganizationsOrgIdPutResponse, UpdateOrganizationV1OrganizationsOrgIdPutError, Options<UpdateOrganizationV1OrganizationsOrgIdPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrganizationV1OrganizationsOrgIdPutResponse, UpdateOrganizationV1OrganizationsOrgIdPutError, Options<UpdateOrganizationV1OrganizationsOrgIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrganizationV1OrganizationsOrgIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Lookup Pdps By Asin
 */
export const lookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostMutation = (options?: Partial<Options<LookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostData>>): UseMutationOptions<LookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostResponse, LookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostError, Options<LookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostData>> => {
    const mutationOptions: UseMutationOptions<LookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostResponse, LookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostError, Options<LookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await lookupPdpsByAsinV1OrganizationsOrgIdPdpsLookupByAsinPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRetailersForOrganizationV1OrganizationsOrgIdRetailersGetQueryKey = (options: Options<GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetData>) => createQueryKey('getRetailersForOrganizationV1OrganizationsOrgIdRetailersGet', options);

/**
 * Get Retailers For Organization
 *
 * List distinct retailer regions available to an organization.
 */
export const getRetailersForOrganizationV1OrganizationsOrgIdRetailersGetOptions = (options: Options<GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetData>) => queryOptions<GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetResponse, GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetError, GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetResponse, ReturnType<typeof getRetailersForOrganizationV1OrganizationsOrgIdRetailersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRetailersForOrganizationV1OrganizationsOrgIdRetailersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRetailersForOrganizationV1OrganizationsOrgIdRetailersGetQueryKey(options)
});

export const getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetQueryKey = (options: Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>) => createQueryKey('getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet', options);

/**
 * Get Users For Organization
 */
export const getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetOptions = (options: Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>) => queryOptions<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponse, GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetError, GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponse, ReturnType<typeof getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetQueryKey(options)
});

export const getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetInfiniteQueryKey = (options: Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>): QueryKey<Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>> => createQueryKey('getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet', options, true);

/**
 * Get Users For Organization
 */
export const getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetInfiniteOptions = (options: Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>) => infiniteQueryOptions<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponse, GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetError, InfiniteData<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponse>, QueryKey<Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>>, number | null | Pick<QueryKey<Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetInfiniteQueryKey(options)
});

export const getOrganizationNameV1InternalOrganizationsOrgIdNameGetQueryKey = (options: Options<GetOrganizationNameV1InternalOrganizationsOrgIdNameGetData>) => createQueryKey('getOrganizationNameV1InternalOrganizationsOrgIdNameGet', options);

/**
 * Get Organization Name
 *
 * Lets Lambdas, which have no DB access, project an org id to its name.
 */
export const getOrganizationNameV1InternalOrganizationsOrgIdNameGetOptions = (options: Options<GetOrganizationNameV1InternalOrganizationsOrgIdNameGetData>) => queryOptions<GetOrganizationNameV1InternalOrganizationsOrgIdNameGetResponse, GetOrganizationNameV1InternalOrganizationsOrgIdNameGetError, GetOrganizationNameV1InternalOrganizationsOrgIdNameGetResponse, ReturnType<typeof getOrganizationNameV1InternalOrganizationsOrgIdNameGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationNameV1InternalOrganizationsOrgIdNameGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationNameV1InternalOrganizationsOrgIdNameGetQueryKey(options)
});

export const exportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetQueryKey = (options: Options<ExportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetData>) => createQueryKey('exportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGet', options);

/**
 * Export Pdps Csv
 *
 * Download PDP search results as CSV with the standard column layout.
 */
export const exportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetOptions = (options: Options<ExportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetData>) => queryOptions<ExportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetResponse, ExportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetError, ExportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetResponse, ReturnType<typeof exportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportPdpsCsvV1WorkspacesWorkspaceIdPdpsExportGetQueryKey(options)
});

export const exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetQueryKey = (options: Options<ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetData>) => createQueryKey('exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGet', options);

/**
 * Export Pdps Csv
 *
 * Download PDP search results as CSV with the standard column layout.
 */
export const exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetOptions = (options: Options<ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetData>) => queryOptions<ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetResponse, ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetError, ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetResponse, ReturnType<typeof exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetQueryKey(options)
});

export const searchPdpsV1WorkspacesWorkspaceIdPdpsGetQueryKey = (options: Options<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetData>) => createQueryKey('searchPdpsV1WorkspacesWorkspaceIdPdpsGet', options);

/**
 * Search Pdps
 */
export const searchPdpsV1WorkspacesWorkspaceIdPdpsGetOptions = (options: Options<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetData>) => queryOptions<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetResponse, SearchPdpsV1WorkspacesWorkspaceIdPdpsGetError, SearchPdpsV1WorkspacesWorkspaceIdPdpsGetResponse, ReturnType<typeof searchPdpsV1WorkspacesWorkspaceIdPdpsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchPdpsV1WorkspacesWorkspaceIdPdpsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchPdpsV1WorkspacesWorkspaceIdPdpsGetQueryKey(options)
});

export const searchPdpsV1WorkspacesWorkspaceIdPdpsGetInfiniteQueryKey = (options: Options<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetData>): QueryKey<Options<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetData>> => createQueryKey('searchPdpsV1WorkspacesWorkspaceIdPdpsGet', options, true);

/**
 * Search Pdps
 */
export const searchPdpsV1WorkspacesWorkspaceIdPdpsGetInfiniteOptions = (options: Options<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetData>) => infiniteQueryOptions<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetResponse, SearchPdpsV1WorkspacesWorkspaceIdPdpsGetError, InfiniteData<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetResponse>, QueryKey<Options<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetData>>, number | Pick<QueryKey<Options<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchPdpsV1WorkspacesWorkspaceIdPdpsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchPdpsV1WorkspacesWorkspaceIdPdpsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchPdpsV1WorkspacesWorkspaceIdPdpsGetInfiniteQueryKey(options)
});

/**
 * Create Pdp
 */
export const createPdpV1WorkspacesWorkspaceIdPdpsPostMutation = (options?: Partial<Options<CreatePdpV1WorkspacesWorkspaceIdPdpsPostData>>): UseMutationOptions<CreatePdpV1WorkspacesWorkspaceIdPdpsPostResponse, CreatePdpV1WorkspacesWorkspaceIdPdpsPostError, Options<CreatePdpV1WorkspacesWorkspaceIdPdpsPostData>> => {
    const mutationOptions: UseMutationOptions<CreatePdpV1WorkspacesWorkspaceIdPdpsPostResponse, CreatePdpV1WorkspacesWorkspaceIdPdpsPostError, Options<CreatePdpV1WorkspacesWorkspaceIdPdpsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPdpV1WorkspacesWorkspaceIdPdpsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchPdpsV1PortfoliosPortfolioIdPdpsGetQueryKey = (options: Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>) => createQueryKey('searchPdpsV1PortfoliosPortfolioIdPdpsGet', options);

/**
 * Search Pdps
 */
export const searchPdpsV1PortfoliosPortfolioIdPdpsGetOptions = (options: Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>) => queryOptions<SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponse, SearchPdpsV1PortfoliosPortfolioIdPdpsGetError, SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponse, ReturnType<typeof searchPdpsV1PortfoliosPortfolioIdPdpsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchPdpsV1PortfoliosPortfolioIdPdpsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchPdpsV1PortfoliosPortfolioIdPdpsGetQueryKey(options)
});

export const searchPdpsV1PortfoliosPortfolioIdPdpsGetInfiniteQueryKey = (options: Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>): QueryKey<Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>> => createQueryKey('searchPdpsV1PortfoliosPortfolioIdPdpsGet', options, true);

/**
 * Search Pdps
 */
export const searchPdpsV1PortfoliosPortfolioIdPdpsGetInfiniteOptions = (options: Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>) => infiniteQueryOptions<SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponse, SearchPdpsV1PortfoliosPortfolioIdPdpsGetError, InfiniteData<SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponse>, QueryKey<Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>>, number | Pick<QueryKey<Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchPdpsV1PortfoliosPortfolioIdPdpsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchPdpsV1PortfoliosPortfolioIdPdpsGetInfiniteQueryKey(options)
});

/**
 * Create Pdp
 */
export const createPdpV1PortfoliosPortfolioIdPdpsPostMutation = (options?: Partial<Options<CreatePdpV1PortfoliosPortfolioIdPdpsPostData>>): UseMutationOptions<CreatePdpV1PortfoliosPortfolioIdPdpsPostResponse, CreatePdpV1PortfoliosPortfolioIdPdpsPostError, Options<CreatePdpV1PortfoliosPortfolioIdPdpsPostData>> => {
    const mutationOptions: UseMutationOptions<CreatePdpV1PortfoliosPortfolioIdPdpsPostResponse, CreatePdpV1PortfoliosPortfolioIdPdpsPostError, Options<CreatePdpV1PortfoliosPortfolioIdPdpsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPdpV1PortfoliosPortfolioIdPdpsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Unlisted Pdp
 *
 * Creates a manually-entered PDP with user-provided data.
 * No external scraping. Item ID is auto-generated in VZT format.
 */
export const createUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostMutation = (options?: Partial<Options<CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostData>>): UseMutationOptions<CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostResponse, CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostError, Options<CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostData>> => {
    const mutationOptions: UseMutationOptions<CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostResponse, CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostError, Options<CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Unlisted Pdp
 *
 * Creates a manually-entered PDP with user-provided data.
 * No external scraping. Item ID is auto-generated in VZT format.
 */
export const createUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostMutation = (options?: Partial<Options<CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData>>): UseMutationOptions<CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostResponse, CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostError, Options<CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData>> => {
    const mutationOptions: UseMutationOptions<CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostResponse, CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostError, Options<CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetQueryKey = (options: Options<GetCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetData>) => createQueryKey('getCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGet', options);

/**
 * Get Current Pdp Content Mix
 *
 * Compare a PDP's images against its product category's ideal content mix.
 *
 * Returns per-asset-type counts ordered by the ideal mix's rank. If the
 * category has no ``ideal_mix`` configured, ``curr_content_mix`` is empty.
 */
export const getCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetOptions = (options: Options<GetCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetData>) => queryOptions<GetCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetResponse, GetCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetError, GetCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetResponse, ReturnType<typeof getCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCurrentPdpContentMixV1WorkspacesWorkspaceIdPdpsPdpIdIdealMixGetQueryKey(options)
});

export const getCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetQueryKey = (options: Options<GetCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetData>) => createQueryKey('getCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGet', options);

/**
 * Get Current Pdp Content Mix
 *
 * Compare a PDP's images against its product category's ideal content mix.
 *
 * Returns per-asset-type counts ordered by the ideal mix's rank. If the
 * category has no ``ideal_mix`` configured, ``curr_content_mix`` is empty.
 */
export const getCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetOptions = (options: Options<GetCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetData>) => queryOptions<GetCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetResponse, GetCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetError, GetCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetResponse, ReturnType<typeof getCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCurrentPdpContentMixV1PortfoliosPortfolioIdPdpsPdpIdIdealMixGetQueryKey(options)
});

/**
 * Delete Pdp
 *
 * Delete a PDP from a portfolio and all its associated images.
 */
export const deletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteMutation = (options?: Partial<Options<DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteData>>): UseMutationOptions<DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteResponse, DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteError, Options<DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteResponse, DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteError, Options<DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetQueryKey = (options: Options<GetPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetData>) => createQueryKey('getPdpV1WorkspacesWorkspaceIdPdpsPdpIdGet', options);

/**
 * Get Pdp
 */
export const getPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetOptions = (options: Options<GetPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetData>) => queryOptions<GetPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetResponse, GetPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetError, GetPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetResponse, ReturnType<typeof getPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPdpV1WorkspacesWorkspaceIdPdpsPdpIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPdpV1WorkspacesWorkspaceIdPdpsPdpIdGetQueryKey(options)
});

/**
 * Update Pdp
 */
export const updatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutMutation = (options?: Partial<Options<UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutData>>): UseMutationOptions<UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutResponse, UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutError, Options<UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutData>> => {
    const mutationOptions: UseMutationOptions<UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutResponse, UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutError, Options<UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Pdp
 *
 * Delete a PDP from a portfolio and all its associated images.
 */
export const deletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteMutation = (options?: Partial<Options<DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData>>): UseMutationOptions<DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteResponse, DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteError, Options<DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteResponse, DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteError, Options<DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePdpV1PortfoliosPortfolioIdPdpsPdpIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPdpV1PortfoliosPortfolioIdPdpsPdpIdGetQueryKey = (options: Options<GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetData>) => createQueryKey('getPdpV1PortfoliosPortfolioIdPdpsPdpIdGet', options);

/**
 * Get Pdp
 */
export const getPdpV1PortfoliosPortfolioIdPdpsPdpIdGetOptions = (options: Options<GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetData>) => queryOptions<GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetResponse, GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetError, GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetResponse, ReturnType<typeof getPdpV1PortfoliosPortfolioIdPdpsPdpIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPdpV1PortfoliosPortfolioIdPdpsPdpIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPdpV1PortfoliosPortfolioIdPdpsPdpIdGetQueryKey(options)
});

/**
 * Update Pdp
 */
export const updatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutMutation = (options?: Partial<Options<UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData>>): UseMutationOptions<UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutResponse, UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutError, Options<UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData>> => {
    const mutationOptions: UseMutationOptions<UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutResponse, UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutError, Options<UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePdpV1PortfoliosPortfolioIdPdpsPdpIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complex Search Pdps
 *
 * Complex PDP search with nested query conditions.
 *
 * Supports:
 * - Nested AND/OR logical conditions
 * - Multiple comparison operators (=, !=, >, >=, <, <=, like, ilike, in, not_in, is_null, is_not_null)
 * - Multi-field sorting
 * - Pagination
 *
 * Note: 'like' and 'ilike' automatically perform substring matching (no manual wildcards needed)
 *
 * Example request body:
 * ```json
 * {
 * "query": {
 * "operator": "and",
 * "conditions": [
 * {
 * "operator": "or",
 * "conditions": [
 * {"comparator": "=", "field": "brand", "value": "lindt"},
 * {"comparator": "ilike", "field": "name", "value": "lindt"}
 * ]
 * },
 * {
 * "comparator": "in",
 * "field": "product_category_id",
 * "value": ["uuid-1", "uuid-2"]
 * },
 * {
 * "comparator": "in",
 * "field": "listing_score_level",
 * "value": ["high", "very_high"]
 * }
 * ]
 * },
 * "order": [
 * {"field": "listing_score", "direction": "desc"}
 * ],
 * "pagination": {
 * "offset": 0,
 * "limit": 10
 * }
 * }
 * ```
 *
 * Available fields:
 * - brand, name, item_id, retailer, source_type, score_status
 * - listing_score, listing_score_at_ingest, raw_listing_score
 * - score_change (listing_score minus score at ingest; NULL for formula-served rows; e.g. '!=' 0 finds changed products; unscored/NULL excluded; not sortable)
 * - listing_score_level (use with 'in' comparator and values: very_low, low, moderate, high, very_high)
 * - product_category_id, product_category_name
 * - category_id (retailer category ID string; dedupes across retailers; supports '=' and 'in')
 * - created_at, updated_at
 */
export const complexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostMutation = (options?: Partial<Options<ComplexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostData>>): UseMutationOptions<ComplexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostResponse, ComplexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostError, Options<ComplexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostData>> => {
    const mutationOptions: UseMutationOptions<ComplexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostResponse, ComplexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostError, Options<ComplexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await complexSearchPdpsV1WorkspacesWorkspaceIdPdpsSearchPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complex Search Pdps
 *
 * Complex PDP search with nested query conditions.
 *
 * Supports:
 * - Nested AND/OR logical conditions
 * - Multiple comparison operators (=, !=, >, >=, <, <=, like, ilike, in, not_in, is_null, is_not_null)
 * - Multi-field sorting
 * - Pagination
 *
 * Note: 'like' and 'ilike' automatically perform substring matching (no manual wildcards needed)
 *
 * Example request body:
 * ```json
 * {
 * "query": {
 * "operator": "and",
 * "conditions": [
 * {
 * "operator": "or",
 * "conditions": [
 * {"comparator": "=", "field": "brand", "value": "lindt"},
 * {"comparator": "ilike", "field": "name", "value": "lindt"}
 * ]
 * },
 * {
 * "comparator": "in",
 * "field": "product_category_id",
 * "value": ["uuid-1", "uuid-2"]
 * },
 * {
 * "comparator": "in",
 * "field": "listing_score_level",
 * "value": ["high", "very_high"]
 * }
 * ]
 * },
 * "order": [
 * {"field": "listing_score", "direction": "desc"}
 * ],
 * "pagination": {
 * "offset": 0,
 * "limit": 10
 * }
 * }
 * ```
 *
 * Available fields:
 * - brand, name, item_id, retailer, source_type, score_status
 * - listing_score, listing_score_at_ingest, raw_listing_score
 * - score_change (listing_score minus score at ingest; NULL for formula-served rows; e.g. '!=' 0 finds changed products; unscored/NULL excluded; not sortable)
 * - listing_score_level (use with 'in' comparator and values: very_low, low, moderate, high, very_high)
 * - product_category_id, product_category_name
 * - category_id (retailer category ID string; dedupes across retailers; supports '=' and 'in')
 * - created_at, updated_at
 */
export const complexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostMutation = (options?: Partial<Options<ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostData>>): UseMutationOptions<ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostResponse, ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostError, Options<ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostData>> => {
    const mutationOptions: UseMutationOptions<ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostResponse, ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostError, Options<ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await complexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Pdp Title Brand
 */
export const updatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchMutation = (options?: Partial<Options<UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchData>>): UseMutationOptions<UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchResponse, UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchError, Options<UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchResponse, UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchError, Options<UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Pdp Title Brand
 */
export const updatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchMutation = (options?: Partial<Options<UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData>>): UseMutationOptions<UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchResponse, UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchError, Options<UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchResponse, UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchError, Options<UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetQueryKey = (options: Options<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetData>) => createQueryKey('searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGet', options);

/**
 * Search Pdp Images
 *
 * Retrieves images linked to a specific PDP with pagination support.
 * Default sort by PdpImage.created_at.
 */
export const searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetOptions = (options: Options<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetData>) => queryOptions<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetResponse, SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetError, SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetResponse, ReturnType<typeof searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetQueryKey(options)
});

export const searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetInfiniteQueryKey = (options: Options<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetData>): QueryKey<Options<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetData>> => createQueryKey('searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGet', options, true);

/**
 * Search Pdp Images
 *
 * Retrieves images linked to a specific PDP with pagination support.
 * Default sort by PdpImage.created_at.
 */
export const searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetInfiniteOptions = (options: Options<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetData>) => infiniteQueryOptions<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetResponse, SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetError, InfiniteData<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetResponse>, QueryKey<Options<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetData>>, number | Pick<QueryKey<Options<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchPdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesGetInfiniteQueryKey(options)
});

/**
 * Create Pdp Image
 *
 * Creates an Image linked to a Pdp and returns the Image model
 */
export const createPdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostMutation = (options?: Partial<Options<CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostData>>): UseMutationOptions<CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostResponse, CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostError, Options<CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostData>> => {
    const mutationOptions: UseMutationOptions<CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostResponse, CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostError, Options<CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetQueryKey = (options: Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>) => createQueryKey('searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet', options);

/**
 * Search Pdp Images
 *
 * Retrieves images linked to a specific PDP with pagination support.
 * Default sort by PdpImage.created_at.
 */
export const searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetOptions = (options: Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>) => queryOptions<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponse, SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetError, SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponse, ReturnType<typeof searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetQueryKey(options)
});

export const searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetInfiniteQueryKey = (options: Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>): QueryKey<Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>> => createQueryKey('searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet', options, true);

/**
 * Search Pdp Images
 *
 * Retrieves images linked to a specific PDP with pagination support.
 * Default sort by PdpImage.created_at.
 */
export const searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetInfiniteOptions = (options: Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>) => infiniteQueryOptions<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponse, SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetError, InfiniteData<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponse>, QueryKey<Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>>, number | Pick<QueryKey<Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetInfiniteQueryKey(options)
});

/**
 * Create Pdp Image
 *
 * Creates an Image linked to a Pdp and returns the Image model
 */
export const createPdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostMutation = (options?: Partial<Options<CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData>>): UseMutationOptions<CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostResponse, CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostError, Options<CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData>> => {
    const mutationOptions: UseMutationOptions<CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostResponse, CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostError, Options<CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Create Pdp Images
 *
 * Creates multiple images linked to a PDP in a single transaction.
 *
 * Idempotency:
 * - If all requested images already exist (by name), returns them with 200
 * - If no images exist, creates all and returns 201
 * - If some exist and some don't, returns 409 Conflict
 */
export const bulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostMutation = (options?: Partial<Options<BulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostData>>): UseMutationOptions<BulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostResponse, BulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostError, Options<BulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostData>> => {
    const mutationOptions: UseMutationOptions<BulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostResponse, BulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostError, Options<BulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkCreatePdpImagesV1WorkspacesWorkspaceIdPdpsPdpIdImagesBulkPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Create Pdp Images
 *
 * Creates multiple images linked to a PDP in a single transaction.
 *
 * Idempotency:
 * - If all requested images already exist (by name), returns them with 200
 * - If no images exist, creates all and returns 201
 * - If some exist and some don't, returns 409 Conflict
 */
export const bulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostMutation = (options?: Partial<Options<BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostData>>): UseMutationOptions<BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostResponse, BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostError, Options<BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostData>> => {
    const mutationOptions: UseMutationOptions<BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostResponse, BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostError, Options<BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Pdp Image
 *
 * Delete an image from a PDP. Cannot delete active hero or carousel images.
 */
export const deletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteMutation = (options?: Partial<Options<DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteData>>): UseMutationOptions<DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteResponse, DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteError, Options<DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteResponse, DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteError, Options<DeletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesImageIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Pdp Image
 *
 * Delete an image from a PDP. Cannot delete active hero or carousel images.
 */
export const deletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteMutation = (options?: Partial<Options<DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData>>): UseMutationOptions<DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteResponse, DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteError, Options<DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteResponse, DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteError, Options<DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetQueryKey = (options: Options<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetData>) => createQueryKey('getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGet', options);

/**
 * Get Portfolio Brands
 *
 * Scope is the workspace on the workspace mount, the whole portfolio on the legacy mount.
 */
export const getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetOptions = (options: Options<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetData>) => queryOptions<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetResponse, GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetError, GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetResponse, ReturnType<typeof getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetQueryKey(options)
});

export const getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetInfiniteQueryKey = (options: Options<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetData>): QueryKey<Options<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetData>> => createQueryKey('getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGet', options, true);

/**
 * Get Portfolio Brands
 *
 * Scope is the workspace on the workspace mount, the whole portfolio on the legacy mount.
 */
export const getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetInfiniteOptions = (options: Options<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetData>) => infiniteQueryOptions<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetResponse, GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetError, InfiniteData<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetResponse>, QueryKey<Options<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetData>>, number | Pick<QueryKey<Options<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortfolioBrandsV1WorkspacesWorkspaceIdBrandsGetInfiniteQueryKey(options)
});

export const getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetQueryKey = (options: Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>) => createQueryKey('getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet', options);

/**
 * Get Portfolio Brands
 *
 * Scope is the workspace on the workspace mount, the whole portfolio on the legacy mount.
 */
export const getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetOptions = (options: Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>) => queryOptions<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponse, GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetError, GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponse, ReturnType<typeof getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetQueryKey(options)
});

export const getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetInfiniteQueryKey = (options: Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>): QueryKey<Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>> => createQueryKey('getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet', options, true);

/**
 * Get Portfolio Brands
 *
 * Scope is the workspace on the workspace mount, the whole portfolio on the legacy mount.
 */
export const getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetInfiniteOptions = (options: Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>) => infiniteQueryOptions<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponse, GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetError, InfiniteData<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponse>, QueryKey<Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>>, number | Pick<QueryKey<Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetInfiniteQueryKey(options)
});

/**
 * Refresh Pdp
 */
export const refreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostMutation = (options?: Partial<Options<RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostData>>): UseMutationOptions<unknown, RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostError, Options<RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostError, Options<RefreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refreshPdpV1WorkspacesWorkspaceIdPdpsPdpIdRefreshPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh Pdp
 */
export const refreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostMutation = (options?: Partial<Options<RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData>>): UseMutationOptions<unknown, RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostError, Options<RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostError, Options<RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPdpScoringContextV1InternalPdpsPdpIdScoringContextGetQueryKey = (options: Options<GetPdpScoringContextV1InternalPdpsPdpIdScoringContextGetData>) => createQueryKey('getPdpScoringContextV1InternalPdpsPdpIdScoringContextGet', options);

/**
 * Get Pdp Scoring Context
 */
export const getPdpScoringContextV1InternalPdpsPdpIdScoringContextGetOptions = (options: Options<GetPdpScoringContextV1InternalPdpsPdpIdScoringContextGetData>) => queryOptions<GetPdpScoringContextV1InternalPdpsPdpIdScoringContextGetResponse, GetPdpScoringContextV1InternalPdpsPdpIdScoringContextGetError, GetPdpScoringContextV1InternalPdpsPdpIdScoringContextGetResponse, ReturnType<typeof getPdpScoringContextV1InternalPdpsPdpIdScoringContextGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPdpScoringContextV1InternalPdpsPdpIdScoringContextGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPdpScoringContextV1InternalPdpsPdpIdScoringContextGetQueryKey(options)
});

export const getPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetQueryKey = (options: Options<GetPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetData>) => createQueryKey('getPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGet', options);

/**
 * Get Pdp Scraping Context
 */
export const getPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetOptions = (options: Options<GetPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetData>) => queryOptions<GetPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetResponse, GetPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetError, GetPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetResponse, ReturnType<typeof getPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPdpScrapingContextV1InternalPdpsRequestIdScrapingContextGetQueryKey(options)
});

/**
 * Post Scoring Complete
 */
export const postScoringCompleteV1InternalPdpsPdpIdScoringCompletePostMutation = (options?: Partial<Options<PostScoringCompleteV1InternalPdpsPdpIdScoringCompletePostData>>): UseMutationOptions<PostScoringCompleteV1InternalPdpsPdpIdScoringCompletePostResponse, PostScoringCompleteV1InternalPdpsPdpIdScoringCompletePostError, Options<PostScoringCompleteV1InternalPdpsPdpIdScoringCompletePostData>> => {
    const mutationOptions: UseMutationOptions<PostScoringCompleteV1InternalPdpsPdpIdScoringCompletePostResponse, PostScoringCompleteV1InternalPdpsPdpIdScoringCompletePostError, Options<PostScoringCompleteV1InternalPdpsPdpIdScoringCompletePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postScoringCompleteV1InternalPdpsPdpIdScoringCompletePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Pdp Category
 */
export const setPdpCategoryV1InternalPdpsPdpIdSetCategoryPostMutation = (options?: Partial<Options<SetPdpCategoryV1InternalPdpsPdpIdSetCategoryPostData>>): UseMutationOptions<SetPdpCategoryV1InternalPdpsPdpIdSetCategoryPostResponse, SetPdpCategoryV1InternalPdpsPdpIdSetCategoryPostError, Options<SetPdpCategoryV1InternalPdpsPdpIdSetCategoryPostData>> => {
    const mutationOptions: UseMutationOptions<SetPdpCategoryV1InternalPdpsPdpIdSetCategoryPostResponse, SetPdpCategoryV1InternalPdpsPdpIdSetCategoryPostError, Options<SetPdpCategoryV1InternalPdpsPdpIdSetCategoryPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setPdpCategoryV1InternalPdpsPdpIdSetCategoryPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Create Images Internal
 */
export const bulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostMutation = (options?: Partial<Options<BulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostData>>): UseMutationOptions<BulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostResponse, BulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostError, Options<BulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostData>> => {
    const mutationOptions: UseMutationOptions<BulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostResponse, BulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostError, Options<BulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkCreateImagesInternalV1InternalPdpsPdpIdImagesBulkCreatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Scrape Complete
 */
export const scrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostMutation = (options?: Partial<Options<ScrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostData>>): UseMutationOptions<ScrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostResponse, ScrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostError, Options<ScrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostData>> => {
    const mutationOptions: UseMutationOptions<ScrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostResponse, ScrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostError, Options<ScrapeCompleteV1InternalPdpsPdpIdScrapeCompletePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await scrapeCompleteV1InternalPdpsPdpIdScrapeCompletePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getScrapedPdpV1PdpsRequestIdGetQueryKey = (options: Options<GetScrapedPdpV1PdpsRequestIdGetData>) => createQueryKey('getScrapedPdpV1PdpsRequestIdGet', options);

/**
 * Get Scraped Pdp
 */
export const getScrapedPdpV1PdpsRequestIdGetOptions = (options: Options<GetScrapedPdpV1PdpsRequestIdGetData>) => queryOptions<GetScrapedPdpV1PdpsRequestIdGetResponse, GetScrapedPdpV1PdpsRequestIdGetError, GetScrapedPdpV1PdpsRequestIdGetResponse, ReturnType<typeof getScrapedPdpV1PdpsRequestIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getScrapedPdpV1PdpsRequestIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getScrapedPdpV1PdpsRequestIdGetQueryKey(options)
});

/**
 * Handle Category Not Found
 */
export const handleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostMutation = (options?: Partial<Options<HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostData>>): UseMutationOptions<unknown, HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostError, Options<HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostError, Options<HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Pdp Snapshot
 */
export const createPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostMutation = (options?: Partial<Options<CreatePdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostData>>): UseMutationOptions<CreatePdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostResponse, CreatePdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostError, Options<CreatePdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostData>> => {
    const mutationOptions: UseMutationOptions<CreatePdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostResponse, CreatePdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostError, Options<CreatePdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Pdp Snapshot
 */
export const createPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostMutation = (options?: Partial<Options<CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostData>>): UseMutationOptions<CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostResponse, CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostError, Options<CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostData>> => {
    const mutationOptions: UseMutationOptions<CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostResponse, CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostError, Options<CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Latest Snapshot Scores
 */
export const updateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutMutation = (options?: Partial<Options<UpdateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutData>>): UseMutationOptions<UpdateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutResponse, UpdateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutError, Options<UpdateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutResponse, UpdateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutError, Options<UpdateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateLatestSnapshotScoresV1WorkspacesWorkspaceIdPdpsPdpIdSnapshotsLatestScoresPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Latest Snapshot Scores
 */
export const updateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutMutation = (options?: Partial<Options<UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutData>>): UseMutationOptions<UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutResponse, UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutError, Options<UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutResponse, UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutError, Options<UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetQueryKey = (options: Options<GetOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetData>) => createQueryKey('getOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGet', options);

/**
 * Get Original Pdp Snapshot
 */
export const getOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetOptions = (options: Options<GetOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetData>) => queryOptions<GetOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetResponse, GetOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetError, GetOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetResponse, ReturnType<typeof getOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOriginalPdpSnapshotV1WorkspacesWorkspaceIdPdpsPdpIdOriginalGetQueryKey(options)
});

export const getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetQueryKey = (options: Options<GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetData>) => createQueryKey('getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGet', options);

/**
 * Get Original Pdp Snapshot
 */
export const getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetOptions = (options: Options<GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetData>) => queryOptions<GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetResponse, GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetError, GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetResponse, ReturnType<typeof getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetQueryKey(options)
});

export const getProductCategoriesV1ProductCategoriesGetQueryKey = (options?: Options<GetProductCategoriesV1ProductCategoriesGetData>) => createQueryKey('getProductCategoriesV1ProductCategoriesGet', options);

/**
 * Get Product Categories
 *
 * Retrieves the product categories for an organization
 * The product category names will be formatted in title-case
 *
 * Filters:
 * - breadcrumbs_like: Filter by breadcrumb path containing this string
 * - name_like: Filter by category name containing this string
 * - category_ids: Filter by specific category IDs
 * - scope_to_portfolio: Filter by categories used in PDPs or images for the current portfolio
 * - fallback: If true, try benchmark_lookup.json when no category_ids matches found
 */
export const getProductCategoriesV1ProductCategoriesGetOptions = (options?: Options<GetProductCategoriesV1ProductCategoriesGetData>) => queryOptions<GetProductCategoriesV1ProductCategoriesGetResponse, GetProductCategoriesV1ProductCategoriesGetError, GetProductCategoriesV1ProductCategoriesGetResponse, ReturnType<typeof getProductCategoriesV1ProductCategoriesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductCategoriesV1ProductCategoriesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductCategoriesV1ProductCategoriesGetQueryKey(options)
});

export const getProductCategoriesV1ProductCategoriesGetInfiniteQueryKey = (options?: Options<GetProductCategoriesV1ProductCategoriesGetData>): QueryKey<Options<GetProductCategoriesV1ProductCategoriesGetData>> => createQueryKey('getProductCategoriesV1ProductCategoriesGet', options, true);

/**
 * Get Product Categories
 *
 * Retrieves the product categories for an organization
 * The product category names will be formatted in title-case
 *
 * Filters:
 * - breadcrumbs_like: Filter by breadcrumb path containing this string
 * - name_like: Filter by category name containing this string
 * - category_ids: Filter by specific category IDs
 * - scope_to_portfolio: Filter by categories used in PDPs or images for the current portfolio
 * - fallback: If true, try benchmark_lookup.json when no category_ids matches found
 */
export const getProductCategoriesV1ProductCategoriesGetInfiniteOptions = (options?: Options<GetProductCategoriesV1ProductCategoriesGetData>) => infiniteQueryOptions<GetProductCategoriesV1ProductCategoriesGetResponse, GetProductCategoriesV1ProductCategoriesGetError, InfiniteData<GetProductCategoriesV1ProductCategoriesGetResponse>, QueryKey<Options<GetProductCategoriesV1ProductCategoriesGetData>>, number | Pick<QueryKey<Options<GetProductCategoriesV1ProductCategoriesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetProductCategoriesV1ProductCategoriesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getProductCategoriesV1ProductCategoriesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductCategoriesV1ProductCategoriesGetInfiniteQueryKey(options)
});

/**
 * Classify By Title
 *
 * Resolve a product_category_id from a product title (Cosmo classifier).
 *
 * Walmart-only for now. The retailer-scraping Lambda calls this for Walmart
 * PDPs, which don't carry Amazon-style category_ids; Amazon products keep
 * using GET /v1/product-categories?category_ids=... as before.
 *
 * Failure handling matches the synchronous create_pdp flow: when Cosmo can't
 * classify confidently, the lookup result raises a 4xx with a stable
 * error_code. Callers (the scraping Lambda) should treat that as
 * "no category" and continue, not as a hard failure.
 */
export const classifyByTitleV1ProductCategoriesClassifyByTitlePostMutation = (options?: Partial<Options<ClassifyByTitleV1ProductCategoriesClassifyByTitlePostData>>): UseMutationOptions<ClassifyByTitleV1ProductCategoriesClassifyByTitlePostResponse, ClassifyByTitleV1ProductCategoriesClassifyByTitlePostError, Options<ClassifyByTitleV1ProductCategoriesClassifyByTitlePostData>> => {
    const mutationOptions: UseMutationOptions<ClassifyByTitleV1ProductCategoriesClassifyByTitlePostResponse, ClassifyByTitleV1ProductCategoriesClassifyByTitlePostError, Options<ClassifyByTitleV1ProductCategoriesClassifyByTitlePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await classifyByTitleV1ProductCategoriesClassifyByTitlePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProductCategoryV1ProductCategoriesCategoryIdGetQueryKey = (options: Options<GetProductCategoryV1ProductCategoriesCategoryIdGetData>) => createQueryKey('getProductCategoryV1ProductCategoriesCategoryIdGet', options);

/**
 * Get Product Category
 *
 * Retrieves a single product category by ID or breadcrumbs
 */
export const getProductCategoryV1ProductCategoriesCategoryIdGetOptions = (options: Options<GetProductCategoryV1ProductCategoriesCategoryIdGetData>) => queryOptions<GetProductCategoryV1ProductCategoriesCategoryIdGetResponse, GetProductCategoryV1ProductCategoriesCategoryIdGetError, GetProductCategoryV1ProductCategoriesCategoryIdGetResponse, ReturnType<typeof getProductCategoryV1ProductCategoriesCategoryIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductCategoryV1ProductCategoriesCategoryIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductCategoryV1ProductCategoriesCategoryIdGetQueryKey(options)
});

export const getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetQueryKey = (options: Options<GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetData>) => createQueryKey('getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGet', options);

/**
 * Get Product Category Audience Name
 *
 * Retrieves the audience name and version for a product category by UUID
 */
export const getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetOptions = (options: Options<GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetData>) => queryOptions<GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetResponse, GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetError, GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetResponse, ReturnType<typeof getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetQueryKey(options)
});

/**
 * Post Product Category Vizit Scores
 *
 * Convert raw model scores to vizit percentiles, in request order.
 */
export const postProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostMutation = (options?: Partial<Options<PostProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostData>>): UseMutationOptions<PostProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostResponse, PostProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostError, Options<PostProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostData>> => {
    const mutationOptions: UseMutationOptions<PostProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostResponse, PostProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostError, Options<PostProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postProductCategoryVizitScoresV1ProductCategoriesProductCategoryIdVizitScoresPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIcpProductCategoriesV1IcpProductCategoriesGetQueryKey = (options?: Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>) => createQueryKey('getIcpProductCategoriesV1IcpProductCategoriesGet', options);

/**
 * Get Icp Product Categories
 */
export const getIcpProductCategoriesV1IcpProductCategoriesGetOptions = (options?: Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>) => queryOptions<GetIcpProductCategoriesV1IcpProductCategoriesGetResponse, GetIcpProductCategoriesV1IcpProductCategoriesGetError, GetIcpProductCategoriesV1IcpProductCategoriesGetResponse, ReturnType<typeof getIcpProductCategoriesV1IcpProductCategoriesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIcpProductCategoriesV1IcpProductCategoriesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIcpProductCategoriesV1IcpProductCategoriesGetQueryKey(options)
});

export const getIcpProductCategoriesV1IcpProductCategoriesGetInfiniteQueryKey = (options?: Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>): QueryKey<Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>> => createQueryKey('getIcpProductCategoriesV1IcpProductCategoriesGet', options, true);

/**
 * Get Icp Product Categories
 */
export const getIcpProductCategoriesV1IcpProductCategoriesGetInfiniteOptions = (options?: Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>) => infiniteQueryOptions<GetIcpProductCategoriesV1IcpProductCategoriesGetResponse, GetIcpProductCategoriesV1IcpProductCategoriesGetError, InfiniteData<GetIcpProductCategoriesV1IcpProductCategoriesGetResponse>, QueryKey<Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>>, number | Pick<QueryKey<Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getIcpProductCategoriesV1IcpProductCategoriesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIcpProductCategoriesV1IcpProductCategoriesGetInfiniteQueryKey(options)
});

export const getIcpProductCategoriesV1L1ProductCategoriesGetQueryKey = (options?: Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>) => createQueryKey('getIcpProductCategoriesV1L1ProductCategoriesGet', options);

/**
 * Get Icp Product Categories
 *
 * @deprecated
 */
export const getIcpProductCategoriesV1L1ProductCategoriesGetOptions = (options?: Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>) => queryOptions<GetIcpProductCategoriesV1L1ProductCategoriesGetResponse, GetIcpProductCategoriesV1L1ProductCategoriesGetError, GetIcpProductCategoriesV1L1ProductCategoriesGetResponse, ReturnType<typeof getIcpProductCategoriesV1L1ProductCategoriesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIcpProductCategoriesV1L1ProductCategoriesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIcpProductCategoriesV1L1ProductCategoriesGetQueryKey(options)
});

export const getIcpProductCategoriesV1L1ProductCategoriesGetInfiniteQueryKey = (options?: Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>): QueryKey<Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>> => createQueryKey('getIcpProductCategoriesV1L1ProductCategoriesGet', options, true);

/**
 * Get Icp Product Categories
 *
 * @deprecated
 */
export const getIcpProductCategoriesV1L1ProductCategoriesGetInfiniteOptions = (options?: Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>) => infiniteQueryOptions<GetIcpProductCategoriesV1L1ProductCategoriesGetResponse, GetIcpProductCategoriesV1L1ProductCategoriesGetError, InfiniteData<GetIcpProductCategoriesV1L1ProductCategoriesGetResponse>, QueryKey<Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>>, number | Pick<QueryKey<Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getIcpProductCategoriesV1L1ProductCategoriesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIcpProductCategoriesV1L1ProductCategoriesGetInfiniteQueryKey(options)
});

export const getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetQueryKey = (options: Options<GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetData>) => createQueryKey('getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGet', options);

/**
 * Get Icp Product Category
 *
 * @deprecated
 */
export const getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetOptions = (options: Options<GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetData>) => queryOptions<GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetResponse, GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetError, GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetResponse, ReturnType<typeof getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetQueryKey(options)
});

export const getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetQueryKey = (options: Options<GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetData>) => createQueryKey('getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGet', options);

/**
 * Get Icp Product Category
 */
export const getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetOptions = (options: Options<GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetData>) => queryOptions<GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetResponse, GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetError, GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetResponse, ReturnType<typeof getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetQueryKey(options)
});

export const lookupCategoriesV1InternalProductCategoriesLookupGetQueryKey = (options: Options<LookupCategoriesV1InternalProductCategoriesLookupGetData>) => createQueryKey('lookupCategoriesV1InternalProductCategoriesLookupGet', options);

/**
 * Lookup Categories
 */
export const lookupCategoriesV1InternalProductCategoriesLookupGetOptions = (options: Options<LookupCategoriesV1InternalProductCategoriesLookupGetData>) => queryOptions<LookupCategoriesV1InternalProductCategoriesLookupGetResponse, LookupCategoriesV1InternalProductCategoriesLookupGetError, LookupCategoriesV1InternalProductCategoriesLookupGetResponse, ReturnType<typeof lookupCategoriesV1InternalProductCategoriesLookupGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await lookupCategoriesV1InternalProductCategoriesLookupGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: lookupCategoriesV1InternalProductCategoriesLookupGetQueryKey(options)
});

export const getRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetQueryKey = (options: Options<GetRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetData>) => createQueryKey('getRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGet', options);

/**
 * Get Recommendations
 */
export const getRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetOptions = (options: Options<GetRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetData>) => queryOptions<GetRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetResponse, GetRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetError, GetRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetResponse, ReturnType<typeof getRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecommendationsV1WorkspacesWorkspaceIdPdpsPdpIdRecommendationsGetQueryKey(options)
});

export const getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetQueryKey = (options: Options<GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetData>) => createQueryKey('getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGet', options);

/**
 * Get Recommendations
 */
export const getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetOptions = (options: Options<GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetData>) => queryOptions<GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetResponse, GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetError, GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetResponse, ReturnType<typeof getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetQueryKey(options)
});

/**
 * Start Amazon Vendor Authorization
 */
export const startAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPostMutation = (options?: Partial<Options<StartAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPostData>>): UseMutationOptions<StartAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPostResponse, DefaultError, Options<StartAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPostData>> => {
    const mutationOptions: UseMutationOptions<StartAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPostResponse, DefaultError, Options<StartAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const completeAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGetQueryKey = (options?: Options<CompleteAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGetData>) => createQueryKey('completeAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGet', options);

/**
 * Complete Amazon Vendor Authorization
 */
export const completeAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGetOptions = (options?: Options<CompleteAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGetData>) => queryOptions<unknown, CompleteAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGetError, unknown, ReturnType<typeof completeAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await completeAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: completeAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthCallbackGetQueryKey(options)
});

export const listAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetQueryKey = (options?: Options<ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetData>) => createQueryKey('listAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGet', options);

/**
 * List Amazon Vendor Connections
 */
export const listAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetOptions = (options?: Options<ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetData>) => queryOptions<ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetResponse, ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetError, ListAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetResponse, ReturnType<typeof listAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAmazonVendorConnectionsV1IntegrationsAmazonVendorConnectionsGetQueryKey(options)
});

/**
 * Disconnect Amazon Vendor Connection
 *
 * Clears the refresh token Vizit holds. Amazon exposes no app-callable revoke, so the authorization stays live on Amazon's side until the customer removes the application in Vendor Central.
 */
export const disconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteMutation = (options?: Partial<Options<DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteData>>): UseMutationOptions<DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteResponse, DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteError, Options<DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteResponse, DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteError, Options<DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRetailerRegionsV1RetailerRegionsGetQueryKey = (options?: Options<ListRetailerRegionsV1RetailerRegionsGetData>) => createQueryKey('listRetailerRegionsV1RetailerRegionsGet', options);

/**
 * List Retailer Regions
 *
 * List all supported retailer/region combinations.
 */
export const listRetailerRegionsV1RetailerRegionsGetOptions = (options?: Options<ListRetailerRegionsV1RetailerRegionsGetData>) => queryOptions<ListRetailerRegionsV1RetailerRegionsGetResponse, ListRetailerRegionsV1RetailerRegionsGetError, ListRetailerRegionsV1RetailerRegionsGetResponse, ReturnType<typeof listRetailerRegionsV1RetailerRegionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRetailerRegionsV1RetailerRegionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRetailerRegionsV1RetailerRegionsGetQueryKey(options)
});

export const getRetailerRegionV1RetailerRegionsRetailerRegionIdGetQueryKey = (options: Options<GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetData>) => createQueryKey('getRetailerRegionV1RetailerRegionsRetailerRegionIdGet', options);

/**
 * Get Retailer Region
 *
 * Get a specific retailer/region by ID (e.g., 'amazon_uk').
 */
export const getRetailerRegionV1RetailerRegionsRetailerRegionIdGetOptions = (options: Options<GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetData>) => queryOptions<GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetResponse, GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetError, GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetResponse, ReturnType<typeof getRetailerRegionV1RetailerRegionsRetailerRegionIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRetailerRegionV1RetailerRegionsRetailerRegionIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRetailerRegionV1RetailerRegionsRetailerRegionIdGetQueryKey(options)
});

export const searchRoleAssignmentsV1RoleAssignmentsGetQueryKey = (options: Options<SearchRoleAssignmentsV1RoleAssignmentsGetData>) => createQueryKey('searchRoleAssignmentsV1RoleAssignmentsGet', options);

/**
 * Search Role Assignments
 */
export const searchRoleAssignmentsV1RoleAssignmentsGetOptions = (options: Options<SearchRoleAssignmentsV1RoleAssignmentsGetData>) => queryOptions<SearchRoleAssignmentsV1RoleAssignmentsGetResponse, SearchRoleAssignmentsV1RoleAssignmentsGetError, SearchRoleAssignmentsV1RoleAssignmentsGetResponse, ReturnType<typeof searchRoleAssignmentsV1RoleAssignmentsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchRoleAssignmentsV1RoleAssignmentsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchRoleAssignmentsV1RoleAssignmentsGetQueryKey(options)
});

/**
 * Create Role Assignment
 */
export const createRoleAssignmentV1RoleAssignmentsPostMutation = (options?: Partial<Options<CreateRoleAssignmentV1RoleAssignmentsPostData>>): UseMutationOptions<CreateRoleAssignmentV1RoleAssignmentsPostResponse, CreateRoleAssignmentV1RoleAssignmentsPostError, Options<CreateRoleAssignmentV1RoleAssignmentsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateRoleAssignmentV1RoleAssignmentsPostResponse, CreateRoleAssignmentV1RoleAssignmentsPostError, Options<CreateRoleAssignmentV1RoleAssignmentsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createRoleAssignmentV1RoleAssignmentsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Role Assignment
 */
export const deleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteMutation = (options?: Partial<Options<DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteData>>): UseMutationOptions<DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteResponse, DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteError, Options<DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteResponse, DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteError, Options<DeleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteRoleAssignmentV1RoleAssignmentsRoleAssignmentIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add User To Organization
 */
export const addUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostMutation = (options?: Partial<Options<AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData>>): UseMutationOptions<AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostResponse, AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostError, Options<AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData>> => {
    const mutationOptions: UseMutationOptions<AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostResponse, AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostError, Options<AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete User
 */
export const deleteUserV1UsersUserIdDeleteMutation = (options?: Partial<Options<DeleteUserV1UsersUserIdDeleteData>>): UseMutationOptions<DeleteUserV1UsersUserIdDeleteResponse, DeleteUserV1UsersUserIdDeleteError, Options<DeleteUserV1UsersUserIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteUserV1UsersUserIdDeleteResponse, DeleteUserV1UsersUserIdDeleteError, Options<DeleteUserV1UsersUserIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUserV1UsersUserIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserV1UsersUserIdGetQueryKey = (options: Options<GetUserV1UsersUserIdGetData>) => createQueryKey('getUserV1UsersUserIdGet', options);

/**
 * Get User
 */
export const getUserV1UsersUserIdGetOptions = (options: Options<GetUserV1UsersUserIdGetData>) => queryOptions<GetUserV1UsersUserIdGetResponse, GetUserV1UsersUserIdGetError, GetUserV1UsersUserIdGetResponse, ReturnType<typeof getUserV1UsersUserIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserV1UsersUserIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserV1UsersUserIdGetQueryKey(options)
});

/**
 * Set Password
 */
export const setPasswordV1UsersUserIdPasswordPostMutation = (options?: Partial<Options<SetPasswordV1UsersUserIdPasswordPostData>>): UseMutationOptions<SetPasswordV1UsersUserIdPasswordPostResponse, SetPasswordV1UsersUserIdPasswordPostError, Options<SetPasswordV1UsersUserIdPasswordPostData>> => {
    const mutationOptions: UseMutationOptions<SetPasswordV1UsersUserIdPasswordPostResponse, SetPasswordV1UsersUserIdPasswordPostError, Options<SetPasswordV1UsersUserIdPasswordPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setPasswordV1UsersUserIdPasswordPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset Password
 */
export const resetPasswordV1UsersPasswordPutMutation = (options?: Partial<Options<ResetPasswordV1UsersPasswordPutData>>): UseMutationOptions<unknown, ResetPasswordV1UsersPasswordPutError, Options<ResetPasswordV1UsersPasswordPutData>> => {
    const mutationOptions: UseMutationOptions<unknown, ResetPasswordV1UsersPasswordPutError, Options<ResetPasswordV1UsersPasswordPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetPasswordV1UsersPasswordPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Login User
 */
export const loginUserV1UsersAuthenticatePostMutation = (options?: Partial<Options<LoginUserV1UsersAuthenticatePostData>>): UseMutationOptions<LoginUserV1UsersAuthenticatePostResponse, LoginUserV1UsersAuthenticatePostError, Options<LoginUserV1UsersAuthenticatePostData>> => {
    const mutationOptions: UseMutationOptions<LoginUserV1UsersAuthenticatePostResponse, LoginUserV1UsersAuthenticatePostError, Options<LoginUserV1UsersAuthenticatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginUserV1UsersAuthenticatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Exchange Token
 */
export const exchangeTokenV1OrganizationsOrganizationIdAuthorizePostMutation = (options?: Partial<Options<ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData>>): UseMutationOptions<ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostResponse, ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostError, Options<ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData>> => {
    const mutationOptions: UseMutationOptions<ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostResponse, ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostError, Options<ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exchangeTokenV1OrganizationsOrganizationIdAuthorizePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove User From Organization
 */
export const removeUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteMutation = (options?: Partial<Options<RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData>>): UseMutationOptions<RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteResponse, RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteError, Options<RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteResponse, RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteError, Options<RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrganizationsForUserV1UsersUserIdOrganizationsGetQueryKey = (options: Options<GetOrganizationsForUserV1UsersUserIdOrganizationsGetData>) => createQueryKey('getOrganizationsForUserV1UsersUserIdOrganizationsGet', options);

/**
 * Get Organizations For User
 */
export const getOrganizationsForUserV1UsersUserIdOrganizationsGetOptions = (options: Options<GetOrganizationsForUserV1UsersUserIdOrganizationsGetData>) => queryOptions<GetOrganizationsForUserV1UsersUserIdOrganizationsGetResponse, GetOrganizationsForUserV1UsersUserIdOrganizationsGetError, GetOrganizationsForUserV1UsersUserIdOrganizationsGetResponse, ReturnType<typeof getOrganizationsForUserV1UsersUserIdOrganizationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationsForUserV1UsersUserIdOrganizationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationsForUserV1UsersUserIdOrganizationsGetQueryKey(options)
});

/**
 * Logout User
 */
export const logoutUserV1UsersUserIdLogoutPostMutation = (options?: Partial<Options<LogoutUserV1UsersUserIdLogoutPostData>>): UseMutationOptions<unknown, LogoutUserV1UsersUserIdLogoutPostError, Options<LogoutUserV1UsersUserIdLogoutPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, LogoutUserV1UsersUserIdLogoutPostError, Options<LogoutUserV1UsersUserIdLogoutPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logoutUserV1UsersUserIdLogoutPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resend Invite
 */
export const resendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostMutation = (options?: Partial<Options<ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData>>): UseMutationOptions<ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostResponse, ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostError, Options<ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData>> => {
    const mutationOptions: UseMutationOptions<ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostResponse, ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostError, Options<ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Retailer Preference
 */
export const updateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutMutation = (options?: Partial<Options<UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutData>>): UseMutationOptions<UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutResponse, UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutError, Options<UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutData>> => {
    const mutationOptions: UseMutationOptions<UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutResponse, UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutError, Options<UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWorkspaceBySlugV1WorkspacesBySlugSlugGetQueryKey = (options: Options<GetWorkspaceBySlugV1WorkspacesBySlugSlugGetData>) => createQueryKey('getWorkspaceBySlugV1WorkspacesBySlugSlugGet', options);

/**
 * Get Workspace By Slug
 */
export const getWorkspaceBySlugV1WorkspacesBySlugSlugGetOptions = (options: Options<GetWorkspaceBySlugV1WorkspacesBySlugSlugGetData>) => queryOptions<GetWorkspaceBySlugV1WorkspacesBySlugSlugGetResponse, GetWorkspaceBySlugV1WorkspacesBySlugSlugGetError, GetWorkspaceBySlugV1WorkspacesBySlugSlugGetResponse, ReturnType<typeof getWorkspaceBySlugV1WorkspacesBySlugSlugGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWorkspaceBySlugV1WorkspacesBySlugSlugGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWorkspaceBySlugV1WorkspacesBySlugSlugGetQueryKey(options)
});

export const healthcheckHealthcheckGetQueryKey = (options?: Options<HealthcheckHealthcheckGetData>) => createQueryKey('healthcheckHealthcheckGet', options);

/**
 * Healthcheck
 *
 * Ping the server. Async so it never queues for a worker thread; keep it non-blocking.
 */
export const healthcheckHealthcheckGetOptions = (options?: Options<HealthcheckHealthcheckGetData>) => queryOptions<HealthcheckHealthcheckGetResponse, DefaultError, HealthcheckHealthcheckGetResponse, ReturnType<typeof healthcheckHealthcheckGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthcheckHealthcheckGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthcheckHealthcheckGetQueryKey(options)
});

export const healthcheckGetQueryKey = (options?: Options<HealthcheckGetData>) => createQueryKey('healthcheckGet', options);

/**
 * Healthcheck
 *
 * Ping the server. Async so it never queues for a worker thread; keep it non-blocking.
 */
export const healthcheckGetOptions = (options?: Options<HealthcheckGetData>) => queryOptions<HealthcheckGetResponse, DefaultError, HealthcheckGetResponse, ReturnType<typeof healthcheckGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthcheckGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthcheckGetQueryKey(options)
});

export const readyReadyGetQueryKey = (options?: Options<ReadyReadyGetData>) => createQueryKey('readyReadyGet', options);

/**
 * Ready
 *
 * Check the state of the API and the services it depends on
 */
export const readyReadyGetOptions = (options?: Options<ReadyReadyGetData>) => queryOptions<ReadyReadyGetResponse, DefaultError, ReadyReadyGetResponse, ReturnType<typeof readyReadyGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await readyReadyGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readyReadyGetQueryKey(options)
});
